var _metadata, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsidoraSansSemiBold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Tue Sep 12 23:01:46 2017\n By Aleksey,,,\nCopyright (c) 2017 by Enrique Hernandez Vasquez. All rights reserved.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "IsidoraSans-SemiBold",
    horizAdvX: 1476
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Isidora Sans SemiBold",
    fontWeight: 600,
    fontStretch: "normal",
    unitsPerEm: 2048,
    panose1: "0 0 7 0 0 0 0 0 0 0",
    ascent: 1638,
    descent: -410,
    xHeight: 1024,
    capHeight: 1331,
    bbox: "-346 -524 2636 1880",
    underlineThickness: 0,
    underlinePosition: 0,
    unicodeRange: "U+0020-FB02"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 1228
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniFB01",
    unicode: "fi",
    horizAdvX: 1216,
    d: "M958 1147q-58 0 -102 42q-43 42 -43 102q0 59 43 102t103 43q59 0 101 -43t42 -103q0 -57 -43 -100t-101 -43zM453 1024h614v-1024h-223v850h-391v-850h-222v850h-174v174h174v29q0 179 101 280q100 99 256 99q89 0 164 -37l8 -17l-51 -139l-19 -8q-40 20 -80 20 q-158 0 -157 -198v-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniFB02",
    unicode: "fl",
    horizAdvX: 1196,
    d: "M821 1399l205 18l18 -12v-1405h-223v1176q-63 76 -186 75q-83 0 -132 -55q-50 -56 -50 -143v-29h280v-174h-280v-850h-222v850h-174v174h174v29q0 167 108 274q107 105 271 105q119 0 211 -62v29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 1228
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "glyph1",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "glyph2",
    horizAdvX: 681
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 479
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 546,
    d: "M350 381h-153l-13 16l-28 930l12 16h209l12 -16l-24 -930zM381 21q-45 -46 -108 -46q-64 0 -109 46q-45 45 -45 109q0 63 45 108t109 45q63 0 108 -45t45 -108q0 -64 -45 -109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 694,
    d: "M262 819h-121l-39 512h199zM551 819h-119l-39 512h197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 1259,
    d: "M422 0h-178l51 365h-232l21 147h231l43 307h-231l20 148h232l49 362h178l-49 -362h264l49 362h179l-50 -362h193l-21 -148h-194l-41 -307h192l-20 -147h-193l-51 -365h-178l53 365h-266zM537 819l-43 -307h264l43 307h-264z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 1005,
    d: "M922 414q0 -133 -85 -218q-84 -84 -229 -110v-156h-176v156q-236 33 -366 207v18l106 115h16q60 -75 146 -121q86 -47 170 -47q92 0 148.5 43t56.5 111q0 74 -59 111q-39 22 -56 30t-83 31q-58 19 -85 30q-127 48 -202 107q-105 81 -105 223q0 124 86 210q85 85 227 106 v155h176v-158q194 -31 291 -159v-19l-106 -116h-17q-106 133 -264 133q-81 0 -130.5 -38t-49.5 -101q0 -65 45 -99q46 -35 139 -72q8 -3 62 -21q46 -15 65 -24q35 -16 59 -25q42 -17 61 -30q5 -4 12 -8.5t18.5 -12t19.5 -13.5q16 -11 28 -23.5t17.5 -20.5t16.5 -26.5 t16 -26.5q31 -50 31 -141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 1699,
    d: "M612 695q-88 -109 -229 -109t-229 109q-88 107 -88 282q0 177 88 284q89 107 229 107t229 -107q88 -107 88 -284q0 -175 -88 -282zM242 -6l-11 16l1037 1333h180l10 -16l-1034 -1333h-182zM383 735q68 0 111 67q43 65 43 175q0 111 -42 176.5t-112 65.5t-112 -66 t-42 -176q0 -109 42 -175q42 -67 112 -67zM1544 77q-88 -108 -229 -108t-229 108q-89 107 -89 284q0 175 89 284q89 107 229 107t229 -107q88 -107 88 -284q0 -178 -88 -284zM1203 184q42 -65 112 -65q69 0 111 66q42 64 42 175q0 108 -42 176q-42 66 -111 66 q-70 0 -112 -66q-42 -67 -42 -176q0 -112 42 -176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 1339,
    d: "M1268 152l14 -9l45 -129l-6 -14q-62 -43 -162 -43q-117 0 -211 70q-136 -72 -301 -72q-245 0 -408 147q-165 146 -165 361q0 257 237 399q-19 38 -30 66q-19 52 -21 112q0 150 102 244q100 94 267 94q215 0 350 -174v-14l-119 -100h-16q-82 122 -207 114 q-79 -2 -126.5 -46.5t-47.5 -113.5q0 -37 26 -91q24 -50 45 -77l78 -102l357 -475q45 73 45 162q0 130 -92 227v17l137 104h16q143 -143 144 -348q0 -177 -119 -314q35 -27 74 -26q48 0 94 31zM287 463q0 -139 106 -236q106 -98 258 -98q97 0 176 41l-338 442l-73 103 q-129 -96 -129 -252z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 403,
    d: "M262 819h-121l-39 512h199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 636,
    d: "M390 1104q-81 -232 -81 -469.5t81 -466.5q80 -228 224 -406h-231q-141 188 -221 415q-80 228 -80 458q0 229 80 460q79 228 221 416h231q-143 -176 -224 -407z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 636,
    d: "M254 -238h-231q143 176 224 406t81 467t-81 469q-81 231 -224 407h231q142 -188 221 -416q80 -231 80 -460q0 -230 -80 -458q-79 -224 -221 -415z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 899,
    d: "M377 1128v244h145v-244l211 123l74 -125l-213 -122l213 -123l-74 -125l-211 123v-246h-145v246l-211 -123l-74 125l213 123l-213 122l74 125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 1116,
    d: "M655 702h400v-178h-400v-389h-192v389h-402v178h402v385h192v-385z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 505,
    d: "M162 -328h-19l-57 56v16q137 175 137 229q-57 12 -93 54.5t-36 99.5q0 64 46 110t112 46q72 0 115 -45t43 -119q2 -159 -248 -447z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 976,
    d: "M125 526v176h727v-176h-727z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 485,
    d: "M351 21q-46 -46 -109 -46q-64 0 -109 46q-45 45 -45 109q0 63 45 108t109 45q66 0 111 -45q44 -46 44 -108q0 -64 -46 -109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 1107,
    d: "M39 -92l821 1534h201l8 -17l-819 -1534h-201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 1286,
    d: "M1043 1178q151 -193 151 -508q0 -317 -151 -508q-151 -193 -400 -193q-246 0 -397 193q-152 193 -152 508q0 314 152 508q152 192 397 192q248 0 400 -192zM409 1035q-90 -139 -90 -365t90 -365q88 -139 234 -139q145 0 235 139q89 140 89 365t-89 365q-90 139 -235 139 q-146 0 -234 -139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 704,
    d: "M37 1153v193h481v-1352h-225v1159h-256z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 1099,
    d: "M401 180h621v-186h-948v158q103 103 239 234q169 164 224 222q116 121 163 199q50 83 50 160q0 98 -63.5 156.5t-170.5 58.5q-170 0 -299 -160h-18l-115 113v16q180 219 455 219q196 0 314 -109t118 -286q0 -183 -219 -434q-98 -112 -351 -361z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 1107,
    d: "M776 719q112 -51 175 -143.5t63 -208.5q0 -176 -135 -287q-137 -111 -353 -111q-144 0 -270 58q-125 56 -209 161v17l119 117h16q136 -166 336 -166q117 0 192 63q74 62 74 160q0 113 -87 183q-87 69 -222 69h-100v160h106q112 0 188 59q74 59 74 149q0 81 -62 134 q-63 51 -163 51q-168 0 -282 -121h-19l-106 119v18q175 170 434 170q189 0 307 -99q119 -101 119 -255q0 -93 -52 -171t-143 -126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 1169,
    d: "M905 -6h-227v305h-641v156l713 891h155v-865h191v-182h-191v-305zM690 981l-401 -500h401v500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 1153,
    d: "M592 901q217 0 351 -128t134 -337q0 -206 -144 -336q-146 -131 -370 -131q-145 0 -278 60q-131 57 -209 157v17l121 114h16q59 -72 151 -116q92 -45 183 -45q133 0 218 79q85 78 85 201q0 128 -82 204q-83 77 -215 77q-87 0 -161 -37t-118 -90h-18l-143 67l110 689h756 v-193h-592l-47 -311q116 59 252 59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 1155,
    d: "M627 897q209 0 344 -129t135 -334q0 -204 -143 -335q-143 -130 -367 -130q-252 0 -397 162q-110 124 -115 324q-2 295 285 663q99 128 256 291h18l137 -119v-16q-139 -135 -239 -256q-70 -85 -127 -174q101 53 213 53zM390 233q80 -79 206 -79t206 79q81 78 81 199 q0 122 -82 201q-83 80 -205 80t-205 -80q-82 -79 -82 -201q0 -121 81 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 983,
    d: "M37 1346h913v-117l-530 -1235h-223l-11 12l496 1147h-645v193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 1210,
    d: "M891 754q111 -53 173 -147.5t62 -213.5q0 -186 -146 -305t-376 -119q-227 0 -373 119q-147 118 -147 305q0 118 61 211t172 150q-137 96 -137 264q0 156 119 254t305 98q188 0 307 -98t119 -254q0 -170 -139 -264zM754 1142q-59 52 -150 52q-90 0 -148 -52 q-59 -53 -59 -132q0 -81 59 -134t148 -53t150 53q59 53 59 134q0 79 -59 132zM394 220q82 -73 210 -73t211 73q84 74 84 183q0 113 -84 187q-85 74 -211 74q-127 0 -210 -74t-83 -187q0 -111 83 -183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 1155,
    d: "M1071 883q2 -276 -258 -623q-114 -154 -287 -332h-18l-133 123v17q126 120 237 251q65 76 129 175q-96 -52 -194 -54q-216 0 -356 130q-142 130 -142 327q2 215 145 343t365 128q226 0 368 -133q143 -134 144 -352zM559 625q124 0 206 80q81 79 81 200t-81 200 q-80 79 -206 79t-206 -79q-81 -79 -81 -200t82 -200q83 -80 205 -80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 542,
    d: "M272 741q-66 0 -110 45q-45 45 -45 109q0 63 46 109q47 45 110 45t108 -45q45 -47 45 -109q0 -64 -45 -109q-47 -45 -109 -45zM381 21q-45 -46 -108 -46q-64 0 -110 46q-46 45 -46 109q0 63 45 108t110 45q62 0 109 -45q45 -45 45 -108q0 -64 -45 -109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 569,
    d: "M398 782q-46 -45 -109 -45t-110 45q-46 45 -46 111q0 65 46 111q47 45 110 45t109 -45q46 -46 46 -111q0 -66 -46 -111zM197 -328h-19l-57 56v16q137 175 137 229q-57 12 -92 54.5t-35 99.5q0 66 45 111t111 45q70 0 112.5 -45t42.5 -119q2 -86 -56.5 -190.5 t-188.5 -256.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 1032,
    d: "M895 1229l14 -12v-189l-608 -369l608 -364v-189l-14 -12l-836 494v141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 1241,
    d: "M131 733v168h979v-168h-979zM131 328v168h979v-168h-979z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 1032,
    d: "M123 1217l14 12l836 -500v-141l-836 -494l-14 12v189l608 364l-608 369v189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 1030,
    d: "M604 362h-203v50q0 82 30 141q29 57 95 123q16 16 49 45q37 33 57 54q18 18 45 53q50 63 50 139q0 90 -66.5 144t-179.5 54q-79 0 -152 -53q-73 -52 -96 -133l-16 -8l-160 51l-6 16q34 135 160 227q124 91 285 91q200 0 325 -101q123 -102 123 -266q0 -86 -42 -166 q-16 -31 -50 -71q-28 -33 -51 -58q-32 -32 -59 -57q-41 -38 -50 -47q-54 -51 -70 -87q-18 -37 -18 -91v-50zM504 -37q-61 0 -104 43q-44 44 -44 105t43 104t105 43q60 0 103 -43q44 -44 44 -104q0 -61 -44 -105q-43 -43 -103 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 1773,
    d: "M870 -266q-326 0 -557 222t-231 556q0 338 228 558q226 220 575 220q341 0 568 -206q226 -207 226 -513q0 -205 -100 -320q-101 -116 -252 -116q-161 0 -217 125q-111 -123 -291 -123q-167 0 -273 109q-108 108 -108 274t109 278q108 111 272 111q152 0 264 -106v102h154 v-487q0 -139 96 -139q71 0 124 78q52 76 52 214q0 252 -179 411q-178 159 -443 159q-275 0 -454 -176q-179 -177 -179 -453q0 -275 175 -451q175 -178 448 -178q170 0 335 99h17l71 -105v-16q-175 -127 -430 -127zM844 276q99 0 163 66q64 65 64 181q0 115 -64 180 q-65 65 -163 65q-102 0 -164 -69q-62 -71 -62 -176q0 -106 62 -177q61 -70 164 -70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 1394,
    d: "M637 1331h123l614 -1313l-10 -18h-227l-119 270h-649l-121 -270h-219l-11 18zM696 1008l-252 -566h500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 1280,
    d: "M954 700q112 -42 177 -128t65 -201q0 -169 -133 -269q-133 -102 -354 -102h-535v1331h510q213 0 329.5 -92t116.5 -260q0 -184 -176 -279zM909 956q0 94 -60.5 144.5t-172.5 50.5h-275v-389h275q111 0 172 51t61 143zM401 180h285q137 0 210 54.5t73 156.5q0 97 -70 155 t-186 58h-312v-424z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 1396,
    d: "M788 -25q-296 0 -499 198t-203 493t204 493q205 197 501 197q166 0 309.5 -69t242.5 -193v-19l-143 -114h-16q-147 190 -391 190q-203 0 -340 -137q-138 -136 -138 -348t138 -348q137 -138 340 -138q244 0 391 191h16l143 -115v-18q-97 -125 -241 -194t-314 -69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 1499,
    d: "M174 1331h543q315 0 506 -182q190 -181 190 -481q0 -301 -190 -484q-190 -184 -506 -184h-543v1331zM401 193h312q213 0 341 129q128 130 128 344t-128 344q-128 129 -341 129h-312v-946z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 1189,
    d: "M1098 1331v-192h-697v-377h549v-184h-549v-385h699v-193h-926v1331h924z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 1085,
    d: "M1042 1331v-192h-641v-385h506v-187h-506v-567h-227v1331h868z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 1517,
    d: "M1432 739l18 -14q4 -24 4 -78q0 -283 -190 -473q-195 -199 -488 -199q-297 0 -493 196q-197 197 -197 495q0 297 201 494q199 196 491 196q160 0 307 -68q144 -69 238 -190v-17l-143 -120h-19q-69 89 -168 139.5t-211 50.5q-197 0 -332 -137q-135 -136 -135 -348 q0 -213 133 -349q132 -137 332 -137q190 0 324 129q106 107 117 252h-441v178h652z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    d: "M1075 766v565h228v-1331h-228v573h-674v-573h-227v1331h227v-565h674z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 575,
    d: "M174 0v1331h227v-1331h-227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 1026,
    d: "M639 436v895h227v-870q0 -242 -120 -364q-122 -122 -322 -122q-270 0 -418 205v19l137 127h17q101 -144 252 -146q99 0 164 68q63 68 63 188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 1271,
    d: "M1251 1313l-557 -586l570 -709l-11 -18h-247l-476 588l-129 -137v-451h-227v1331h227v-614l586 614h254z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 1042,
    d: "M401 193h615v-193h-842v1331h227v-1138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 1701,
    d: "M1436 1331l163 -1331h-210l-93 850l-385 -850h-116l-379 852l-92 -852h-220l162 1331h123l463 -1014l463 1014h121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    d: "M1077 397v934h223v-1345h-126l-777 936v-922h-223v1331h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 1597,
    d: "M1309 173q-205 -198 -510 -198t-510 198t-205 493t205 493q206 197 510 197t510 -197q204 -198 204 -493t-204 -493zM454 318q138 -138 345 -138t346 138q139 136 139 348t-139 348q-140 137 -346 137t-345 -137q-139 -136 -139 -348t139 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 1245,
    d: "M174 1331h526q235 0 362.5 -109t127.5 -308t-127.5 -308.5t-362.5 -109.5h-299v-496h-227v1331zM401 678h322q111 0 173 60.5t62 168.5q0 111 -62 171.5t-173 60.5h-322v-461z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 1597,
    d: "M1513 666q0 -197 -96 -356q-96 -161 -262 -249l283 -319l-8 -18h-252l-242 264q-60 -11 -137 -13q-305 0 -510 198t-205 493t205 493q206 197 510 197t510 -197q204 -198 204 -493zM454 1014q-139 -136 -139 -348t139 -348q138 -138 345 -138t346 138q139 136 139 348 t-139 348q-140 137 -346 137t-345 -137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 1296,
    d: "M915 561l291 -543l-10 -18h-223l-285 535h-287v-535h-227v1331h535q236 0 362.5 -106t126.5 -297q0 -136 -73.5 -230.5t-209.5 -136.5zM729 1139h-328v-437h328q110 0 174 61q64 60 64 159q0 98 -64 158q-65 59 -174 59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 1169,
    d: "M600 -25q-165 0 -310 68q-144 67 -233 186v19l123 127h19q72 -92 178 -147q107 -56 209 -56q122 0 196 51q72 51 72 133q0 72 -51 121q-20 19 -62 39q-34 16 -72 29q-51 17 -89 30q-45 15 -95 31q-79 29 -125 52q-49 23 -111 68q-124 90 -124 257q0 164 129 269 q130 104 336 104q149 0 271 -54.5t196 -148.5v-18l-121 -127h-16q-136 158 -326 157q-104 0 -171 -46t-67 -122q0 -53 37 -93t78 -58q29 -14 121 -47q12 -5 75 -24q71 -24 80 -28q21 -10 71 -29q56 -23 75 -37q23 -18 60 -41q13 -9 24 -18t18 -15.5t16 -19.5t12.5 -17.5 t13.5 -21t13 -21.5q37 -61 37 -167q0 -176 -137 -280q-136 -105 -350 -105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 1140,
    d: "M1114 1139h-430v-1139h-227v1139h-430v192h1087v-192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    d: "M156 553v778h227v-782q0 -167 99 -267q98 -102 260 -102q161 0 260 102q98 101 98 267v782h221v-778q0 -259 -158 -419q-159 -159 -422 -159t-424 159t-161 419z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 1343,
    d: "M1083 1331h226l10 -18l-586 -1313h-123l-585 1313l10 18h233l404 -966z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1947,
    d: "M1694 1331h217l10 -18l-489 -1313h-121l-338 934l-334 -934h-123l-487 1313l10 18h229l320 -936l325 936h121l332 -946z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 1263,
    d: "M1225 1313l-457 -631l477 -664l-10 -18h-252l-356 512l-363 -512h-239l-11 18l482 652l-453 643l10 18h252l332 -487l338 487h239z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 1323,
    d: "M1270 1331l10 -18l-504 -813v-500h-227v498l-514 815l10 18h227l394 -643l383 643h221z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 1187,
    d: "M1096 1198l-738 -1012h777v-186h-1078v133l742 1012h-705v186h1002v-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 649,
    d: "M580 1511v-168h-199v-1413h199v-168h-412v1749h412z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 1105,
    d: "M47 1442h201l819 -1534l-8 -17h-201l-821 1534z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 649,
    d: "M268 1343h-198v168h411v-1749h-411v168h198v1413z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 1269,
    d: "M575 1331h134l499 -762l-8 -12h-196l-363 553l-375 -553h-196l-9 12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 1146,
    d: "M96 -252v174h955v-174h-955z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 651,
    d: "M176 1546h12l387 -278v-13l-67 -100h-12l-420 225v13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 1128,
    d: "M539 1049q208 0 332 -107q122 -108 122 -317v-625h-192v117q-141 -141 -340 -142q-181 0 -291 91q-111 90 -111 239q0 157 121 251q122 95 318 95q133 0 286 -63v67q0 95 -74 157q-75 60 -192 60q-161 0 -289 -102h-16l-82 125v16q78 64 189 101t219 37zM502 139 q112 0 197 64q85 63 87 159l-2 13v51q-139 70 -264 70q-111 0 -177 -51q-67 -52 -67 -136q0 -76 62 -123t164 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 1294,
    d: "M705 1049q225 0 370 -154q144 -155 144 -383t-145 -382q-146 -155 -369 -155q-213 0 -357 154v-129h-201v1372l207 25l17 -13v-456q140 121 334 121zM674 170q144 0 232 99q89 98 89 243q0 144 -89 244q-89 98 -232 98q-136 0 -228 -90t-92 -252t92 -252t228 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 1095,
    d: "M627 -25q-239 0 -394 154q-157 154 -157 383t157 383q155 154 394 154q264 0 417 -181v-16l-126 -113h-19q-111 115 -268 115q-145 0 -238 -97q-94 -97 -94 -247q0 -147 93 -243q93 -97 245 -97q165 0 262 115h19l126 -113v-16q-153 -181 -417 -181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 1294,
    d: "M924 1372l206 25l17 -13v-1384h-201v131q-141 -156 -354 -156q-224 0 -370 155t-146 382t146 382t370 155q190 0 332 -121v444zM623 170q137 0 228 90t91 252q0 159 -92 251q-91 91 -227 91q-143 0 -233 -98q-91 -98 -91 -244t91 -243q90 -99 233 -99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 1191,
    d: "M1116 457h-817q12 -144 108 -223q95 -80 228 -80q89 0 177 35q87 34 142 100h19l112 -103v-16q-76 -95 -201 -145q-124 -50 -255 -50q-231 0 -391 147q-160 145 -160 388q0 230 150 385q148 154 378 154q220 0 365 -142q152 -148 151 -379q0 -44 -6 -71zM602 874 q-120 0 -202 -71q-81 -72 -99 -193h600q-17 114 -82 178q-83 86 -217 86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 778,
    d: "M635 1251q-83 0 -132.5 -51t-49.5 -147v-29h305v-174h-305v-850h-222v850h-174v174h174v29q0 185 113 283q112 96 270 96q124 0 203 -48l8 -16l-53 -139l-18 -10q-52 32 -119 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 1261,
    d: "M922 911v113h192v-866q0 -241 -149 -366q-149 -124 -379 -124q-152 0 -277.5 56t-204.5 155v19l111 114h16q129 -168 355 -168q140 0 228 73q89 74 89 212v78q-135 -123 -330 -123q-216 0 -355 138q-140 138 -140 345q0 205 141 344q141 138 356 138q209 0 347 -138z M608 262q136 0 221 85q86 86 86 218q0 133 -86 219t-223 86q-135 0 -220 -85t-85 -218q0 -135 85 -220t222 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 1232,
    d: "M369 1384v-462q115 127 307 127q190 0 306 -120q116 -121 116 -313v-616h-224v598q0 118 -66 188q-67 70 -181 70q-116 0 -186 -70q-72 -70 -72 -188v-598h-222v1372l205 25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 524,
    d: "M262 1196q-63 0 -108 46t-45 110q0 63 45 108t109 45q63 0 109 -45t46 -108q0 -66 -45 -111t-111 -45zM373 0h-221v1024h221v-1024z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 522,
    d: "M262 1196q-63 0 -108 46t-45 110q0 63 45 108t109 45q63 0 109 -45t46 -108q0 -66 -45 -111t-111 -45zM152 106v918h223v-920q0 -184 -58 -278q-58 -93 -211 -166h-18l-82 162v16q83 45 115 99q31 55 31 169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 1089,
    d: "M1069 1008l-420 -443l432 -549l-8 -16h-246l-342 444l-114 -120v-324h-224v1372l207 25l17 -13v-841l446 481h242z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 524,
    d: "M373 0h-221v1372l204 25l17 -13v-1384z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 1929,
    d: "M1382 1049q187 0 300 -119q112 -118 112 -314v-616h-223v598q0 119 -62.5 188.5t-171.5 69.5q-112 0 -183 -71q-71 -73 -71 -187v-598h-225v598q0 119 -62.5 188.5t-170.5 69.5q-111 0 -181 -70q-71 -71 -71 -188v-598h-226v1024h197v-135q118 160 334 160 q232 0 342 -179q126 179 362 179z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 1234,
    d: "M678 1049q194 0 309 -120q115 -119 115 -313v-616h-225v598q0 119 -67 189q-67 69 -181 69t-184 -70q-72 -70 -72 -188v-598h-226v1024h197v-133q122 158 334 158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 1259,
    d: "M629 -25q-238 0 -395 154q-158 155 -158 383t158 383q157 154 395 154q241 0 398 -154t157 -383t-157 -383t-398 -154zM629 170q144 0 239 98q93 98 93 244q0 148 -93 245q-94 97 -239 97q-143 0 -236 -97q-94 -97 -94 -245q0 -147 94 -244q93 -98 236 -98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 1294,
    d: "M705 1049q223 0 369 -155q145 -154 145 -382t-144 -382q-146 -155 -370 -155q-195 0 -334 123v-409h-224v1335h197v-121q146 146 361 146zM674 170q144 0 232 99q89 98 89 243q0 144 -89 244q-89 98 -232 98q-136 0 -228 -90t-92 -252t92 -252t228 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 1294,
    d: "M950 903v121h197v-1335h-223v409q-140 -123 -332 -123q-224 0 -370 155t-146 382t146 382t370 155q212 0 358 -146zM623 170q137 0 228 90t91 252q0 159 -92 251q-91 91 -227 91q-143 0 -233 -98q-91 -98 -91 -244t91 -243q90 -99 233 -99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 782,
    d: "M774 1016l10 -17l-55 -163l-18 -9q-38 25 -113 25q-102 0 -164 -80q-63 -80 -63 -205v-567h-224v1024h197v-135q100 160 277 160q85 0 153 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 940,
    d: "M471 -27q-130 0 -240.5 50t-179.5 139v16l113 113h18q45 -60 122 -98q80 -39 163 -39q78 0 127 33.5t49 86.5q0 44 -40 91q-14 14 -49 33q-20 10 -53 25q-6 3 -28.5 11.5t-38.5 14.5q-71 26 -119 48q-44 20 -97 55q-105 70 -105 204q0 133 101 214q100 81 271 81 q112 0 215 -47q102 -49 154 -123v-19l-113 -108h-16q-98 122 -244 120q-68 0 -109.5 -29.5t-41.5 -76.5q0 -46 42 -75q46 -31 142 -70l21 -9q86 -35 128 -57q50 -26 97 -62q100 -75 100 -223q0 -133 -107 -216q-109 -83 -282 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 798,
    d: "M696 215l19 -8l65 -137l-6 -19q-95 -76 -225 -76q-150 0 -244 91q-94 90 -94 260v524h-174v174h174v309l207 25l16 -12v-322h311v-174h-311v-510q0 -172 146 -172q69 0 116 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 1208,
    d: "M838 426v598h223v-1024h-197v123q-112 -146 -317 -148q-184 0 -298 119q-114 118 -114 314v616h223v-608q0 -112 64 -179q63 -69 170 -69q112 0 180 71q66 70 66 187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 1103,
    d: "M872 1024h201l10 -16l-460 -1008h-140l-463 1008l11 16h217l305 -745z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 1593,
    d: "M1350 1024h211l10 -16l-375 -1008h-141l-260 692l-260 -692h-140l-368 1008l10 16h215l225 -717l260 717h119l260 -709z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 1071,
    d: "M1040 1008l-376 -492l389 -500l-11 -16h-235l-281 375l-278 -375h-219l-11 16l392 502l-379 490l10 16h235l271 -365l264 365h221z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 1085,
    d: "M852 1024h201l12 -16l-475 -1086q-63 -140 -137 -198q-74 -56 -185 -56q-101 0 -168 41l-8 19l49 139l19 6q40 -27 100 -27q46 0 76.5 23t56.5 86l51 111l-417 942l12 16h221l297 -729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 995,
    d: "M936 0h-868v156l569 698h-549v170h815v-156l-559 -698h592v-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 675,
    d: "M625 -238h-72q-209 0 -290 83t-81 302v218q0 59 -3 88q-3 26 -14 58q-19 52 -106 52v148q82 0 103 43q20 45 20 155v217q0 220 81 302q81 83 290 83h72v-168h-50q-111 0 -144 -36q-34 -37 -34 -174v-279q0 -98 -40.5 -157.5t-106.5 -59.5q66 0 106.5 -59.5t40.5 -157.5 v-279q0 -137 34 -174t144 -37h50v-168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 507,
    d: "M340 -299h-172v1749h172v-1749z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 675,
    d: "M281 854v279q0 135 -35 173q-34 37 -146 37h-49v168h72q209 0 290 -82q81 -83 81 -303v-217q0 -59 3 -87q3 -27 14 -59q11 -29 35.5 -40.5t69.5 -11.5v-148q-83 0 -102 -43q-20 -45 -20 -155v-218q0 -219 -81 -302t-290 -83h-72v168h49q111 0 146 38t35 173v279 q0 98 40.5 157.5t104.5 59.5q-64 0 -104 60q-41 59 -41 157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 1220,
    d: "M976 564q-54 -19 -134 -19q-78 0 -230 36q-155 35 -235 35q-48 0 -93.5 -20.5t-66.5 -50.5h-16l-78 123v14q27 31 50 51q20 17 74 35t130 18q88 0 254 -35q164 -36 211 -36q117 0 164 71h16l80 -120v-17q-27 -32 -49 -50q-22 -17 -77 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 526,
    d: "M262 741q-63 0 -108 45t-45 109q0 63 45 109q45 45 109 45q63 0 108 -45q45 -47 45 -109q0 -63 -44 -109q-44 -45 -110 -45zM367 -319h-209l-13 16l29 930l12 16h154l14 -16l25 -930z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 1101,
    d: "M625 1006q-143 0 -235 -95q-93 -96 -93 -243q0 -148 90 -242t242 -94q164 0 260 112h16l123 -106v-19q-129 -151 -354 -174v-170h-176v181q-186 37 -301 178q-115 140 -115 336q0 194 115 333q115 140 301 179v170h176v-160q225 -22 354 -174v-19l-123 -106h-16 q-108 113 -264 113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 1134,
    d: "M674 1171q-100 0 -164 -61t-64 -168v-176h373v-176h-373v-412h613v-178h-963v178h125v412h-119v176h119v176q0 189 128 302q127 112 315 112q248 0 399 -187v-16l-121 -109h-16q-111 127 -252 127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 1382,
    d: "M1133 381l139 -135l-142 -137l-143 141q-136 -86 -297 -86q-163 0 -293 86l-147 -141l-141 137l141 135q-96 127 -96 291t94 291l-137 135l141 135l143 -139q136 86 297 86q165 0 295 -88l146 141l141 -135l-139 -135q94 -130 94 -291q0 -164 -96 -291zM458 439 q92 -91 235 -91q142 0 233 91q92 92 92 233q0 140 -92 232q-91 91 -233 91q-143 0 -235 -91q-93 -92 -93 -232q0 -142 93 -233z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 1339,
    d: "M1282 1331l10 -18l-471 -762h242v-133h-275v-121h275v-133h-275v-164h-227v164h-276v133h276v121h-276v133h241l-479 762l10 18h228l393 -643l383 643h221z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 507,
    d: "M168 698v752h172v-752h-172zM168 -299v793h172v-793h-172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 1148,
    d: "M909 1057h-16q-129 129 -305 129q-94 0 -156 -41q-63 -41 -63 -105q0 -66 63 -104q60 -38 195 -82l64.5 -21.5t59.5 -20.5q50 -17 112 -49q66 -34 103 -69q91 -91 91 -209q0 -155 -133 -243q113 -97 112 -224q0 -152 -133 -240q-133 -87 -336 -87q-312 0 -497 200v19 l114 117h17q147 -162 356 -162q109 0 179 45q69 45 69 113q0 54 -43 89q-12 9 -42 31q-22 13 -62 28q-49 19 -62 24l-72 24q-89 30 -155 57q-61 26 -126 66q-128 82 -128 223q0 161 147 250q-127 85 -127 217q0 145 125 235q125 89 320 89q276 0 446 -176v-17zM372 667 q-34 -38 -33.5 -85.5t38.5 -82.5q39 -36 85 -54q46 -19 135 -48q93 -31 136 -51q102 49 103 139q0 77 -84 125q-46 26 -79 39q-39 15 -106 39q-24 9 -104 35q-56 -18 -91 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 882,
    d: "M242 1196q-59 0 -102 43q-44 44 -44 103t43 102t103 43q61 0 103 -43q42 -44 42 -102q0 -60 -42 -103t-103 -43zM641 1196q-59 0 -102 43t-43 103q0 59 43 102t102 43q61 0 103 -43q42 -44 42 -102q0 -60 -42 -103t-103 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 1560,
    d: "M1277 174q-199 -199 -497 -199q-297 0 -496 199q-200 200 -200 492t201 491q199 199 495 199q297 0 497 -200t200 -490q0 -292 -200 -492zM780 109q238 0 397 160q158 160 158 397t-159 397q-160 160 -395 160q-236 0 -396 -160t-160 -397q0 -238 160 -397 q159 -160 395 -160zM801 264q-180 0 -299 116t-119 288q0 174 119 290q118 115 299 115q204 0 323 -135v-16l-100 -103h-14q-74 90 -197 90q-111 0 -174 -68q-64 -68 -64 -173q0 -104 62 -172t176 -68q125 0 197 88h14l100 -102v-15q-114 -135 -323 -135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 798,
    d: "M393 1354q122 0 204 -62q81 -63 81 -174v-416h-137v70q-83 -78 -197 -78t-187 59q-73 58 -73 150q0 96 78 149q77 52 196 52q92 0 168 -27v25q0 55 -41.5 89t-107.5 34q-119 0 -182 -72h-13l-65 80v12q102 109 276 109zM365 813q70 0 113 40q42 41 42 91v25 q-62 25 -147 24q-55 0 -91 -25.5t-36 -66.5t32 -64.5t87 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 1013,
    d: "M535 907v-12l-244 -283l244 -282v-13l-109 -104h-12l-340 385v31l340 383h12zM803 1012l106 -105v-12l-241 -283l241 -282v-13l-106 -104h-15l-337 385v31l337 383h15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 923,
    d: "M194 1270q109 106 269 106t269 -106q108 -106 108 -266q0 -158 -108 -264q-110 -107 -269 -107t-269 107t-110 264q0 159 110 266zM261 804q81 -81 202 -81t202 81q80 82 80 200q0 120 -80 203q-81 81 -202 81q-119 0 -201 -81t-82 -201q0 -121 81 -202zM627 1079 q0 -74 -72 -104l88 -162h-111l-79 148h-45v-148h-101v393h168q73 0 112.5 -33.5t39.5 -93.5zM475 1122h-67v-92h67q22 0 35.5 13t13.5 32q0 47 -49 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "overscore",
    unicode: "\xAF",
    horizAdvX: 1079,
    d: "M236 1229v162h608v-162h-608z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 681,
    d: "M340 827q-110 0 -186 78q-78 78 -78 187q0 112 78 188q76 76 186 76q111 0 188 -77q76 -76 76 -187q0 -110 -76 -187q-77 -78 -188 -78zM340 963q55 0 90 36.5t35 92.5q0 54 -36 91q-36 38 -89 38q-51 0 -87 -38q-36 -37 -36 -91t36 -91q36 -38 87 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 1191,
    d: "M694 1204v-385h400v-180h-400v-389h-194v389h-400v180h400v385h194zM1094 -43h-994v178h994v-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 651,
    d: "M70 1268l387 278h12l100 -153v-13l-419 -225h-15l-65 100v13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 1415,
    d: "M1335 1450v-158h-473v-1575h-168v844h-108q-240 -2 -384 110q-147 111 -147 339q0 227 146 334q145 106 385 106h749zM1026 1151h166v-1434h-166v1434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "middot",
    unicode: "\xB7",
    horizAdvX: 552,
    d: "M276 387q-72 0 -122 50t-50 122q0 71 52 120q52 50 121 50t119 -50t50 -120q0 -72 -50 -122t-120 -50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 684,
    d: "M348 -524q-153 0 -260 82v16l59 90h19q76 -51 162 -51q127 0 127 88q0 66 -74 86t-162 -4l-37 22l66 205v53l170 3v-56l-33 -110q116 0 179 -52t63 -145q0 -102 -77 -165q-77 -62 -202 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 829,
    d: "M660 790q-97 -94 -244 -94q-149 0 -244 94q-96 93 -96 236q0 142 96 237q96 93 244 93q146 0 244 -93q96 -95 96 -237q0 -143 -96 -236zM288 893q50 -51 128 -51t128 51q50 52 50 133t-50 133q-50 51 -128 51t-128 -51q-50 -52 -50 -133t50 -133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 1013,
    d: "M225 1012l338 -383v-31l-338 -385h-12l-109 104v13l244 282l-244 283v12l109 105h12zM588 1012h12l340 -383v-31l-340 -385h-12l-109 104v13l244 282l-244 283v12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 1492,
    d: "M430 578h-192v612h-175v156h367v-768zM164 -6l-10 16l1036 1333h180l10 -16l-1034 -1333h-182zM1315 -6h-166v145h-361v107l375 508h152v-475h88v-140h-88v-145zM1153 530l-188 -251h188v251z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 1622,
    d: "M430 578h-192v614h-175v154h367v-768zM150 -6l-11 16l1037 1333h180l10 -16l-1034 -1333h-182zM1552 -6h-585v104q50 45 140 121q98 82 134 119q105 105 107 168q0 47 -32 75.5t-83 28.5q-95 0 -180 -94h-15l-80 92v15q50 56 134 97q81 40 163 40q121 0 197 -64t76 -178 q0 -61 -33 -117.5t-111 -134.5q-50 -50 -129 -119h295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 1597,
    d: "M508 991q131 -63 131 -192q0 -103 -81 -168q-80 -64 -216 -64q-80 0 -161 35q-79 34 -120 90v15l74 79h15q68 -80 186 -79q57 0 93 28.5t36 75.5q0 53 -42 86t-110 33h-71v112h84q54 0 88.5 28t34.5 73q0 41 -34 66.5t-89 25.5q-95 0 -150 -55h-16l-66 84v14 q97 92 252 92q120 0 191 -58q71 -59 71 -153q0 -111 -100 -168zM283 -6l-11 16l1037 1333h180l10 -16l-1034 -1333h-182zM1411 -6h-166v145h-360v107l375 508h151v-475h88v-140h-88v-145zM1249 530l-188 -251h188v251z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 1015,
    d: "M518 772q-62 0 -105 43q-44 44 -44 105q0 60 44 104q43 43 105 43q60 0 104 -43q44 -44 44 -104q0 -61 -44 -105q-44 -43 -104 -43zM524 -326q-200 0 -324 101q-124 102 -124 266q0 83 43 167q18 34 49 71q44 50 52 58q15 16 58 56q14 14 30.5 29t19.5 18q53 50 71 87 q17 39 17 91v50h202v-50q0 -86 -28 -143q-29 -60 -96 -121q-16 -16 -49 -45q-25 -22 -56 -53q-22 -22 -46 -53q-50 -63 -50 -140q0 -90 68 -144q67 -54 178 -54q81 0 155 54q73 54 92 132l19 6l160 -49l4 -16q-34 -135 -160 -227q-124 -91 -285 -91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 1394,
    d: "M946 1554l-61 -96h-17l-438 207v16l94 152h17l405 -262v-17zM637 1331h123l614 -1313l-10 -18h-227l-119 270h-649l-121 -270h-219l-11 18zM696 1008l-252 -566h500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 1394,
    d: "M971 1665l-439 -207h-16l-59 96v17l403 262h17l94 -152v-16zM637 1331h123l614 -1313l-10 -18h-227l-119 270h-649l-121 -270h-219l-11 18zM696 1008l-252 -566h500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 1394,
    d: "M692 1618l-282 -137h-17l-67 108v17l356 200h20l357 -200v-17l-68 -108h-16zM637 1331h123l614 -1313l-10 -18h-227l-119 270h-649l-121 -270h-219l-11 18zM696 1008l-252 -566h500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 1394,
    d: "M397 1507h-8l-14 11v157q47 84 162 84q59 0 172 -39q112 -39 157 -39q101 0 129 76h9l16 -10v-158q-50 -84 -162 -84q-62 0 -168 39q-108 39 -160 39q-96 0 -133 -76zM637 1331h123l614 -1313l-10 -18h-227l-119 270h-649l-121 -270h-219l-11 18zM696 1008l-252 -566h500 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 1394,
    d: "M477 1481q-63 0 -107 44t-44 105q0 62 44 108q44 44 107 44q60 0 106 -44q44 -44 44 -108q0 -61 -44 -105q-46 -44 -106 -44zM1026 1525q-46 -44 -106 -44q-62 0 -106 44t-44 105q0 62 44 108q44 44 106 44q60 0 106 -44q45 -44 45 -108q0 -62 -45 -105zM637 1331h123 l614 -1313l-10 -18h-227l-119 270h-649l-121 -270h-219l-11 18zM696 1008l-252 -566h500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 1394,
    d: "M858 1503q-68 -65 -159 -65q-92 0 -159 65q-67 64 -67 156q0 93 67 157q65 64 159 64q92 0 159 -64q66 -64 66 -157q0 -91 -66 -156zM698 1751q-37 0 -63.5 -27.5t-26.5 -64.5q0 -39 27 -65.5t63 -26.5q35 0 62.5 27.5t27.5 64.5t-27.5 64.5t-62.5 27.5zM637 1331h123 l614 -1313l-10 -18h-227l-119 270h-649l-121 -270h-219l-11 18zM696 1008l-252 -566h500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 2007,
    d: "M1219 578v-385h698v-193h-926v270h-579l-189 -270h-241l-9 18l928 1313h1014v-192h-696v-377h548v-184h-548zM991 1098l-459 -656h459v656z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 1396,
    d: "M793 1151q-203 0 -340 -137q-138 -136 -138 -348t138 -348q137 -138 340 -138q244 0 391 191h16l143 -115v-18q-87 -112 -212 -179t-277 -82l-20 -65q116 0 178.5 -52t62.5 -145q0 -102 -76 -165q-77 -62 -202 -62q-153 0 -260 82v16l59 90h18q76 -51 162 -51 q127 0 127 88q0 67 -73 86q-74 21 -162 -4l-37 23l53 164q-261 38 -429 227q-169 190 -169 457q0 295 204 493q205 197 501 197q166 0 309.5 -69t242.5 -193v-19l-143 -114h-16q-147 190 -391 190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 1189,
    d: "M477 1833h17l405 -262v-17l-61 -96h-17l-438 207v16zM1098 1331v-192h-697v-377h549v-184h-549v-385h699v-193h-926v1331h924z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 1189,
    d: "M403 1571l404 262h16l95 -152v-16l-439 -207h-16l-60 96v17zM1098 1331v-192h-697v-377h549v-184h-549v-385h699v-193h-926v1331h924z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 1189,
    d: "M633 1618l-283 -137h-16l-68 108v17l357 200h20l356 -200v-17l-67 -108h-17zM401 578v-385h699v-193h-926v1331h924v-192h-697v-377h549v-184h-549z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 1189,
    d: "M416 1481q-63 0 -107 44q-45 43 -45 105t44 108q44 44 108 44q61 0 105 -44t44 -108q0 -61 -44 -105t-105 -44zM965 1525q-46 -44 -106 -44q-62 0 -106 44t-44 105q0 62 44 108q44 44 106 44q60 0 106 -44q45 -44 45 -108q0 -62 -45 -105zM1098 1331v-192h-697v-377h549 v-184h-549v-385h699v-193h-926v1331h924z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 575,
    d: "M147 1833h17l405 -262v-17l-61 -96h-16l-439 207v16zM174 0v1331h227v-1331h-227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 575,
    d: "M12 1571l404 262h16l94 -152v-16l-438 -207h-16l-60 96v17zM174 0v1331h227v-1331h-227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 575,
    d: "M272 1806h21l356 -200v-17l-67 -108h-17l-282 137l-283 -137h-16l-68 108v17zM401 0h-227v1331h227v-1331z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 575,
    d: "M66 1481q-62 0 -108 44q-44 44 -44 105q0 62 44 108q44 44 108 44q61 0 105 -44t44 -108q0 -61 -44 -105t-105 -44zM614 1525q-46 -44 -106 -44q-62 0 -106 44t-44 105q0 62 44 108q44 44 106 44q60 0 106 -44q45 -44 45 -108q0 -62 -45 -105zM174 0v1331h227v-1331h-227 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 1517,
    d: "M193 1331h542q315 0 506 -182t191 -481q0 -301 -190 -484q-190 -184 -507 -184h-542v578h-140v180h140v573zM420 193h311q213 0 341 129q128 130 128 344t-128 344q-128 129 -341 129h-311v-381h356v-180h-356v-385z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    d: "M414 1507h-11l-14 11v157q49 84 174 84q63 0 183 -39t169 -39q109 0 140 76h10l16 -10v-158q-51 -84 -174 -84q-66 0 -181 39q-116 39 -171 39q-104 0 -141 -76zM1077 397v934h223v-1345h-126l-777 936v-922h-223v1331h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 1597,
    d: "M639 1833h16l406 -262v-17l-62 -96h-16l-438 207v16zM1309 173q-205 -198 -510 -198t-510 198t-205 493t205 493q206 197 510 197t510 -197q204 -198 204 -493t-204 -493zM454 318q138 -138 345 -138t346 138q139 136 139 348t-139 348q-140 137 -346 137t-345 -137 q-139 -136 -139 -348t139 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 1597,
    d: "M565 1571l404 262h16l94 -152v-16l-438 -207h-16l-60 96v17zM1309 173q-205 -198 -510 -198t-510 198t-205 493t205 493q206 197 510 197t510 -197q204 -198 204 -493t-204 -493zM454 318q138 -138 345 -138t346 138q139 136 139 348t-139 348q-140 137 -346 137 t-345 -137q-139 -136 -139 -348t139 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 1597,
    d: "M795 1618l-283 -137h-16l-68 108v17l356 200h21l356 -200v-17l-67 -108h-17zM289 1159q206 197 510 197t510 -197q204 -198 204 -493t-204 -493q-205 -198 -510 -198t-510 198t-205 493t205 493zM454 318q138 -138 345 -138t346 138q139 136 139 348t-139 348 q-140 137 -346 137t-345 -137q-139 -136 -139 -348t139 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 1597,
    d: "M973 1505q-65 0 -181 39t-171 39q-105 0 -142 -76h-10l-14 11v157q49 84 174 84q63 0 183 -39t169 -39q109 0 139 76h10l17 -10v-158q-51 -84 -174 -84zM1309 173q-205 -198 -510 -198t-510 198t-205 493t205 493q206 197 510 197t510 -197q204 -198 204 -493t-204 -493z M454 318q138 -138 345 -138t346 138q139 136 139 348t-139 348q-140 137 -346 137t-345 -137q-139 -136 -139 -348t139 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 1597,
    d: "M578 1481q-63 0 -107 44q-45 43 -45 105t44 108q44 44 108 44q61 0 105 -44t44 -108q0 -61 -44 -105t-105 -44zM1126 1525q-46 -44 -106 -44q-62 0 -106 44t-44 105q0 62 44 108q44 44 106 44q60 0 106 -44q45 -44 45 -108q0 -62 -45 -105zM1309 173q-205 -198 -510 -198 t-510 198t-205 493t205 493q206 197 510 197t510 -197q204 -198 204 -493t-204 -493zM454 318q138 -138 345 -138t346 138q139 136 139 348t-139 348q-140 137 -346 137t-345 -137q-139 -136 -139 -348t139 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 1144,
    d: "M569 539l-348 -353l-135 133l352 351l-352 350l141 139l348 -350l351 352l133 -135l-352 -348l356 -356l-139 -140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 1597,
    d: "M1427 1442l-161 -244q118 -97 182.5 -234.5t64.5 -297.5q0 -295 -204 -493q-205 -198 -510 -198q-158 0 -305 62l-97 -146h-211l-10 19l152 227q-244 201 -244 529q0 295 205 493q206 197 510 197q160 0 301 -60l108 164h209zM315 666q0 -205 136 -344l530 796 q-89 33 -182 33q-206 0 -345 -137q-139 -136 -139 -348zM799 180q207 0 346 138q139 136 139 348q0 214 -141 350l-531 -801q90 -35 187 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    d: "M580 1833h16l405 -262v-17l-61 -96h-16l-439 207v16zM156 553v778h227v-782q0 -167 99 -267q98 -102 260 -102q161 0 260 102q98 101 98 267v782h221v-778q0 -259 -158 -419q-159 -159 -422 -159t-424 159t-161 419z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    d: "M506 1571l403 262h17l94 -152v-16l-438 -207h-17l-59 96v17zM156 553v778h227v-782q0 -167 99 -267q98 -102 260 -102q161 0 260 102q98 101 98 267v782h221v-778q0 -259 -158 -419q-159 -159 -422 -159t-424 159t-161 419z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    d: "M735 1618l-282 -137h-17l-67 108v17l356 200h20l357 -200v-17l-68 -108h-16zM1100 549v782h221v-778q0 -259 -158 -419q-159 -159 -422 -159t-424 159t-161 419v778h227v-782q0 -167 99 -267q98 -102 260 -102q161 0 260 102q98 101 98 267z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    d: "M520 1481q-63 0 -107 44t-44 105q0 62 44 108q44 44 107 44q60 0 106 -44q44 -44 44 -108q0 -61 -44 -105q-46 -44 -106 -44zM1069 1525q-46 -44 -106 -44q-62 0 -106 44t-44 105q0 62 44 108q44 44 106 44q60 0 106 -44q45 -44 45 -108q0 -62 -45 -105zM156 553v778h227 v-782q0 -167 99 -267q98 -102 260 -102q161 0 260 102q98 101 98 267v782h221v-778q0 -259 -158 -419q-159 -159 -422 -159t-424 159t-161 419z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 1323,
    d: "M944 1665l-438 -207h-17l-59 96v17l404 262h16l94 -152v-16zM1270 1331l10 -18l-504 -813v-500h-227v498l-514 815l10 18h227l394 -643l383 643h221z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 1267,
    d: "M401 0h-227v1331h227v-244h299q235 0 362.5 -109t127.5 -308q0 -200 -127 -309q-127 -111 -363 -109h-299v-252zM401 895v-461h322q112 0 173.5 60t61.5 170q0 109 -63 170t-172 61h-322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 1239,
    d: "M913 760q121 -43 186.5 -138.5t65.5 -228.5q0 -190 -128 -304q-127 -114 -320 -114q-161 0 -252 70l-8 18l67 138l19 8q66 -45 149 -45q113 0 186 67q72 66 72 183q0 116 -81 187q-82 71 -207 71h-103v151h72q95 0 157 56q60 55 60 145q0 91 -64 146t-168 55 q-110 0 -177 -75q-68 -76 -68 -196v-954h-224v942q0 214 131 345q130 130 338 130q198 0 323 -106q126 -107 126 -273q0 -183 -152 -278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 1128,
    d: "M805 1255l-68 -100h-12l-420 225v13l101 153h12l387 -278v-13zM539 1049q208 0 332 -107q122 -108 122 -317v-625h-192v117q-141 -141 -340 -142q-181 0 -291 91q-111 90 -111 239q0 157 121 251q122 95 318 95q133 0 286 -63v67q0 95 -74 157q-75 60 -192 60 q-161 0 -289 -102h-16l-82 125v16q78 64 189 101t219 37zM502 139q112 0 197 64q85 63 87 159l-2 13v51q-139 70 -264 70q-111 0 -177 -51q-67 -52 -67 -136q0 -76 62 -123t164 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 1128,
    d: "M799 1380l-420 -225h-14l-66 100v13l387 278h12l101 -153v-13zM539 1049q208 0 332 -107q122 -108 122 -317v-625h-192v117q-141 -141 -340 -142q-181 0 -291 91q-111 90 -111 239q0 157 121 251q122 95 318 95q133 0 286 -63v67q0 95 -74 157q-75 60 -192 60 q-161 0 -289 -102h-16l-82 125v16q78 64 189 101t219 37zM502 139q112 0 197 64q85 63 87 159l-2 13v51q-139 70 -264 70q-111 0 -177 -51q-67 -52 -67 -136q0 -76 62 -123t164 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 1128,
    d: "M557 1307l-260 -138h-12l-74 103v14l330 205h30l330 -205v-14l-74 -103h-12zM539 1049q208 0 332 -107q122 -108 122 -317v-625h-192v117q-141 -141 -340 -142q-181 0 -291 91q-111 90 -111 239q0 157 121 251q122 95 318 95q133 0 286 -63v67q0 95 -74 157 q-75 60 -192 60q-161 0 -289 -102h-16l-82 125v16q78 64 189 101t219 37zM502 139q112 0 197 64q85 63 87 159l-2 13v51q-139 70 -264 70q-111 0 -177 -51q-67 -52 -67 -136q0 -76 62 -123t164 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 1128,
    d: "M258 1219h-12l-13 10v145q51 84 170 84q59 0 161 -37t143 -37q115 0 147 72h10l13 -8v-148q-51 -85 -170 -83q-54 0 -154 38q-99 37 -152 37q-110 2 -143 -73zM539 1049q208 0 332 -107q122 -108 122 -317v-625h-192v117q-141 -141 -340 -142q-181 0 -291 91 q-111 90 -111 239q0 157 121 251q122 95 318 95q133 0 286 -63v67q0 95 -74 157q-75 60 -192 60q-161 0 -289 -102h-16l-82 125v16q78 64 189 101t219 37zM502 139q112 0 197 64q85 63 87 159l-2 13v51q-139 70 -264 70q-111 0 -177 -51q-67 -52 -67 -136q0 -76 62 -123 t164 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 1128,
    d: "M356 1196q-59 0 -102 43t-43 103q0 59 43 102t102 43q61 0 104 -43q42 -44 42 -102q0 -60 -42 -103q-43 -43 -104 -43zM756 1196q-59 0 -102 43q-44 44 -44 103t43 102t103 43q61 0 103 -43q42 -44 42 -102q0 -60 -42 -103t-103 -43zM539 1049q208 0 332 -107 q122 -108 122 -317v-625h-192v117q-141 -141 -340 -142q-181 0 -291 91q-111 90 -111 239q0 157 121 251q122 95 318 95q133 0 286 -63v67q0 95 -74 157q-75 60 -192 60q-161 0 -289 -102h-16l-82 125v16q78 64 189 101t219 37zM502 139q112 0 197 64q85 63 87 159l-2 13v51 q-139 70 -264 70q-111 0 -177 -51q-67 -52 -67 -136q0 -76 62 -123t164 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 1128,
    d: "M557 1124q-98 0 -163 65q-66 65 -66 157t66 158q65 65 163 65q95 0 162 -65q65 -67 65 -158q0 -90 -66 -156q-68 -66 -161 -66zM618 1408q-24 24 -61 24t-61 -25q-25 -25 -25 -61q0 -35 24.5 -59.5t61.5 -24.5q36 0 60 24t24 60t-23 62zM539 1049q208 0 332 -107 q122 -108 122 -317v-625h-192v117q-141 -141 -340 -142q-181 0 -291 91q-111 90 -111 239q0 157 121 251q122 95 318 95q133 0 286 -63v67q0 95 -74 157q-75 60 -192 60q-161 0 -289 -102h-16l-82 125v16q78 64 189 101t219 37zM502 139q112 0 197 64q85 63 87 159l-2 13v51 q-139 70 -264 70q-111 0 -177 -51q-67 -52 -67 -136q0 -76 62 -123t164 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 1910,
    d: "M1835 457h-817q12 -144 108 -223q95 -80 228 -80q89 0 177 35q87 34 142 100h19l112 -103v-16q-76 -95 -201 -145q-124 -50 -255 -50q-139 0 -259.5 57.5t-195.5 162.5q-66 -99 -184 -160q-117 -60 -248 -60q-181 0 -291 91q-111 90 -111 239q0 157 121 251 q122 95 318 95q139 0 286 -63v67q0 95 -74 157q-75 60 -192 60q-167 0 -289 -100h-16l-82 125v16q75 62 189 100q112 36 219 36q277 0 389 -175q151 173 397 175q220 0 365 -142q152 -148 151 -379q0 -44 -6 -71zM1321 874q-120 0 -202 -71q-81 -72 -99 -193h600 q-17 114 -82 178q-83 86 -217 86zM502 139q111 0 198 78q86 78 86 178v31q-139 70 -266 70q-109 0 -175 -51q-66 -53 -66 -136q0 -76 62 -123t161 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 1095,
    d: "M631 854q-145 0 -238 -97q-94 -97 -94 -247q0 -147 93 -243q93 -97 245 -97q165 0 262 115h19l126 -113v-16q-131 -156 -350 -176l-20 -68q116 0 178.5 -52t62.5 -145q0 -102 -76 -165q-77 -62 -202 -62q-153 0 -260 82v16l59 90h19q77 -51 161 -51q127 0 127 88 q0 67 -73 86q-74 21 -162 -4l-37 23l53 166q-198 34 -323 180t-125 348q0 229 157 383q155 154 394 154q264 0 417 -181v-16l-126 -113h-19q-109 115 -268 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 1191,
    d: "M850 1255l-68 -100h-12l-420 225v13l101 153h12l387 -278v-13zM1116 457h-817q12 -144 108 -223q95 -80 228 -80q89 0 177 35q87 34 142 100h19l112 -103v-16q-76 -95 -201 -145q-124 -50 -255 -50q-231 0 -391 147q-160 145 -160 388q0 230 150 385q148 154 378 154 q220 0 365 -142q152 -148 151 -379q0 -44 -6 -71zM602 874q-120 0 -202 -71q-81 -72 -99 -193h600q-17 114 -82 178q-83 86 -217 86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 1191,
    d: "M844 1380l-420 -225h-14l-66 100v13l387 278h12l101 -153v-13zM1116 457h-817q12 -144 108 -223q95 -80 228 -80q89 0 177 35q87 34 142 100h19l112 -103v-16q-76 -95 -201 -145q-124 -50 -255 -50q-231 0 -391 147q-160 145 -160 388q0 230 150 385q148 154 378 154 q220 0 365 -142q152 -148 151 -379q0 -44 -6 -71zM602 874q-120 0 -202 -71q-81 -72 -99 -193h600q-17 114 -82 178q-83 86 -217 86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 1191,
    d: "M602 1307l-260 -138h-12l-74 103v14l330 205h30l330 -205v-14l-74 -103h-12zM1116 457h-817q12 -144 108 -223q95 -80 228 -80q89 0 177 35q87 34 142 100h19l112 -103v-16q-76 -95 -201 -145q-124 -50 -255 -50q-231 0 -391 147q-160 145 -160 388q0 230 150 385 q148 154 378 154q220 0 365 -142q152 -148 151 -379q0 -44 -6 -71zM602 874q-120 0 -202 -71q-81 -72 -99 -193h600q-17 114 -82 178q-83 86 -217 86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 1191,
    d: "M401 1196q-59 0 -102 43t-43 103q0 59 43 102t102 43q61 0 104 -43q42 -44 42 -102q0 -60 -42 -103q-43 -43 -104 -43zM801 1196q-59 0 -102 43q-44 44 -44 103t43 102t103 43q61 0 103 -43q42 -44 42 -102q0 -60 -42 -103t-103 -43zM1116 457h-817q12 -144 108 -223 q95 -80 228 -80q89 0 177 35q87 34 142 100h19l112 -103v-16q-76 -95 -201 -145q-124 -50 -255 -50q-231 0 -391 147q-160 145 -160 388q0 230 150 385q148 154 378 154q220 0 365 -142q152 -148 151 -379q0 -44 -6 -71zM602 874q-120 0 -202 -71q-81 -72 -99 -193h600 q-17 114 -82 178q-83 86 -217 86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 524,
    d: "M113 1546h12l387 -278v-13l-68 -100h-12l-420 225v13zM373 0h-221v1024h221v-1024z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 524,
    d: "M6 1268l387 278h13l100 -153v-13l-420 -225h-14l-66 100v13zM373 0h-221v1024h221v-1024z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 524,
    d: "M248 1491h28l299 -205v-14l-67 -103h-10l-236 138l-235 -138h-13l-65 103v14zM373 0h-221v1024h221v-1024z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 524,
    d: "M61 1196q-59 0 -102 43t-43 103q0 59 43 102t102 43q61 0 104 -43q42 -44 42 -102q0 -60 -42 -103q-43 -43 -104 -43zM461 1196q-59 0 -102 43q-44 44 -44 103t43 102t103 43q61 0 103 -43q42 -44 42 -102q0 -60 -42 -103t-103 -43zM373 0h-221v1024h221v-1024z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 1157,
    d: "M975 1180l-182 -66q287 -355 286 -643q-1 -212 -145 -354q-142 -142 -359 -142t-359 139q-142 138 -142 345q0 210 139 346q140 137 344 137q73 0 141 -18q-44 60 -98 120l-219 -79l-14 14v131l131 47q-56 59 -117 117v16l135 115h16q93 -94 162 -176l264 96l17 -10v-135 zM369 243q82 -85 209 -85t208 86q80 86 80 215q0 131 -79 216t-209 85q-129 0 -210 -85t-81 -216t82 -216z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 1234,
    d: "M356 1219h-12l-12 10v145q51 84 170 84q60 0 162 -37q101 -37 141 -37q115 0 147 72h11l12 -8v-148q-51 -85 -170 -83q-54 0 -154 38q-99 37 -151 37q-111 1 -144 -73zM678 1049q194 0 309 -120q115 -119 115 -313v-616h-225v598q0 119 -67 189q-67 69 -181 69t-184 -70 q-72 -70 -72 -188v-598h-226v1024h197v-133q122 158 334 158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 1259,
    d: "M479 1546h13l387 -278v-13l-68 -100h-12l-420 225v13zM629 -25q-238 0 -395 154q-158 155 -158 383t158 383q157 154 395 154q241 0 398 -154t157 -383t-157 -383t-398 -154zM629 170q144 0 239 98q93 98 93 244q0 148 -93 245q-94 97 -239 97q-143 0 -236 -97 q-94 -97 -94 -245q0 -147 94 -244q93 -98 236 -98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 1259,
    d: "M373 1268l387 278h12l100 -153v-13l-419 -225h-15l-65 100v13zM629 -25q-238 0 -395 154q-158 155 -158 383t158 383q157 154 395 154q241 0 398 -154t157 -383t-157 -383t-398 -154zM629 170q144 0 239 98q93 98 93 244q0 148 -93 245q-94 97 -239 97q-143 0 -236 -97 q-94 -97 -94 -245q0 -147 94 -244q93 -98 236 -98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 1259,
    d: "M631 1307l-260 -138h-13l-73 103v14l329 205h31l330 -205v-14l-74 -103h-12zM629 1049q241 0 398 -154t157 -383q0 -228 -158 -383q-157 -154 -397 -154q-238 0 -395 154q-158 155 -158 383t158 383q157 154 395 154zM629 170q144 0 239 98q93 98 93 244q0 148 -93 245 q-94 97 -239 97q-143 0 -236 -97q-94 -97 -94 -245q0 -147 94 -244q93 -98 236 -98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 1259,
    d: "M780 1217q-54 0 -154 38q-99 37 -151 37q-112 0 -143 -73h-13l-12 10v145q51 84 170 84q60 0 162 -37q101 -37 141 -37q115 0 148 72h10l12 -8v-148q-51 -83 -170 -83zM629 -25q-238 0 -395 154q-158 155 -158 383t158 383q157 154 395 154q241 0 398 -154t157 -383 t-157 -383t-398 -154zM629 170q144 0 239 98q93 98 93 244q0 148 -93 245q-94 97 -239 97q-143 0 -236 -97q-94 -97 -94 -245q0 -147 94 -244q93 -98 236 -98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 1259,
    d: "M430 1196q-59 0 -102 43t-43 103q0 59 43 102t102 43q61 0 103 -43q42 -44 42 -102q0 -60 -42 -103t-103 -43zM829 1196q-59 0 -102 43t-43 103q0 59 43 102t102 43q61 0 104 -43q42 -44 42 -102q0 -60 -42 -103q-43 -43 -104 -43zM629 -25q-238 0 -395 154 q-158 155 -158 383t158 383q157 154 395 154q241 0 398 -154t157 -383t-157 -383t-398 -154zM629 170q144 0 239 98q93 98 93 244q0 148 -93 245q-94 97 -239 97q-143 0 -236 -97q-94 -97 -94 -245q0 -147 94 -244q93 -98 236 -98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 1091,
    d: "M553 831q-61 0 -104 42t-43 104q0 61 43 104t104 43q59 0 102 -43t43 -104q0 -62 -43 -104t-102 -42zM88 524v176h916v-176h-916zM553 98q-61 0 -104 42t-43 104q0 61 43 104t104 43q59 0 102 -43t43 -104q0 -62 -43 -104t-102 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 1259,
    d: "M1176 1130l-158 -227q166 -154 166 -391q0 -228 -158 -383q-157 -154 -397 -154q-127 0 -226 43l-81 -116h-207l-11 18l140 199q-168 157 -168 393q0 228 158 383q157 154 395 154q123 0 231 -45l101 145h204zM299 512q0 -124 68 -215l374 539q-52 18 -112 18 q-143 0 -236 -97q-94 -97 -94 -245zM629 170q144 0 239 98q93 98 93 244q0 122 -66 213l-375 -539q52 -16 109 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 1208,
    d: "M846 1255l-68 -100h-12l-420 225v13l100 153h13l387 -278v-13zM838 426v598h223v-1024h-197v123q-112 -146 -317 -148q-184 0 -298 119q-114 118 -114 314v616h223v-608q0 -112 64 -179q63 -69 170 -69q112 0 180 71q66 70 66 187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 1208,
    d: "M840 1380l-420 -225h-14l-66 100v13l387 278h12l101 -153v-13zM838 426v598h223v-1024h-197v123q-112 -146 -317 -148q-184 0 -298 119q-114 118 -114 314v616h223v-608q0 -112 64 -179q63 -69 170 -69q112 0 180 71q66 70 66 187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 1208,
    d: "M598 1307l-260 -138h-12l-74 103v14l330 205h30l330 -205v-14l-74 -103h-12zM838 426v598h223v-1024h-197v123q-112 -146 -317 -148q-184 0 -298 119q-114 118 -114 314v616h223v-608q0 -112 64 -179q63 -69 170 -69q112 0 180 71q66 70 66 187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 1208,
    d: "M397 1196q-59 0 -102 43t-43 103q0 59 43 102t102 43q61 0 104 -43q42 -44 42 -102q0 -60 -42 -103q-43 -43 -104 -43zM797 1196q-59 0 -102 43q-44 44 -44 103t43 102t103 43q61 0 103 -43q42 -44 42 -102q0 -60 -42 -103t-103 -43zM838 426v598h223v-1024h-197v123 q-112 -146 -317 -148q-184 0 -298 119q-114 118 -114 314v616h223v-608q0 -112 64 -179q63 -69 170 -69q112 0 180 71q66 70 66 187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 1085,
    d: "M799 1380l-420 -225h-14l-66 100v13l387 278h12l101 -153v-13zM852 1024h201l12 -16l-475 -1086q-63 -140 -137 -198q-74 -56 -185 -56q-101 0 -168 41l-8 19l49 139l19 6q40 -27 100 -27q46 0 76.5 23t56.5 86l51 111l-417 942l12 16h221l297 -729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 1294,
    d: "M705 1049q223 0 369 -155q145 -154 145 -382t-144 -382q-146 -155 -370 -155q-195 0 -334 123v-409h-224v1642h197v-428q146 146 361 146zM674 170q144 0 232 99q89 98 89 243q0 144 -89 244q-89 98 -232 98q-136 0 -228 -90t-92 -252t92 -252t228 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 1085,
    d: "M356 1196q-59 0 -102 43t-43 103q0 59 43 102t102 43q61 0 104 -43q42 -44 42 -102q0 -60 -42 -103q-43 -43 -104 -43zM756 1196q-59 0 -102 43q-44 44 -44 103t43 102t103 43q61 0 103 -43q42 -44 42 -102q0 -60 -42 -103t-103 -43zM852 1024h201l12 -16l-475 -1086 q-63 -140 -137 -198q-74 -56 -185 -56q-101 0 -168 41l-8 19l49 139l19 6q40 -27 100 -27q46 0 76.5 23t56.5 86l51 111l-417 942l12 16h221l297 -729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 1394,
    d: "M385 1665h625v-162h-625v162zM637 1331h123l614 -1313l-10 -18h-227l-119 270h-649l-121 -270h-219l-11 18zM696 1008l-252 -566h500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 1128,
    d: "M252 1391h608v-162h-608v162zM539 1049q208 0 332 -107q122 -108 122 -317v-625h-192v117q-141 -141 -340 -142q-181 0 -291 91q-111 90 -111 239q0 157 121 251q122 95 318 95q133 0 286 -63v67q0 95 -74 157q-75 60 -192 60q-161 0 -289 -102h-16l-82 125v16 q78 64 189 101t219 37zM502 139q112 0 197 64q85 63 87 159l-2 13v51q-139 70 -264 70q-111 0 -177 -51q-67 -52 -67 -136q0 -76 62 -123t164 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 1394,
    d: "M915 1544q-90 -84 -217 -84q-128 0 -216 84q-90 85 -103 217h164q10 -72 51 -112.5t105 -40.5q63 0 104 41t51 112h164q-13 -132 -103 -217zM637 1331h123l614 -1313l-10 -18h-227l-119 270h-649l-121 -270h-219l-11 18zM696 1008l-252 -566h500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 1128,
    d: "M779 1268q-92 -84 -224 -84q-133 0 -223 84q-91 85 -107 217h164q12 -70 57.5 -112t108.5 -42t108.5 42t57.5 112h164q-16 -133 -106 -217zM539 1049q208 0 332 -107q122 -108 122 -317v-625h-192v117q-141 -141 -340 -142q-181 0 -291 91q-111 90 -111 239 q0 157 121 251q122 95 318 95q133 0 286 -63v67q0 95 -74 157q-75 60 -192 60q-161 0 -289 -102h-16l-82 125v16q78 64 189 101t219 37zM502 139q112 0 197 64q85 63 87 159l-2 13v51q-139 70 -264 70q-111 0 -177 -51q-67 -52 -67 -136q0 -76 62 -123t164 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 1394,
    d: "M1470 -283l19 -4l43 -94l-2 -16q-85 -49 -182 -49q-115 0 -186 62q-72 62 -72 163q0 121 100 221h-53l-119 270h-649l-121 -270h-219l-11 18l619 1313h123l614 -1313l-10 -18l-14 -12q-15 -15 -35 -40q-24 -28 -34 -47q-22 -41 -26 -91q0 -51 35 -84t90 -33q38 0 90 24z M696 1008l-252 -566h500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 1128,
    d: "M1100 -283l18 -4l43 -94l-2 -16q-85 -49 -182 -49q-115 0 -186 62q-72 62 -72 163q0 121 100 221h-18v117q-141 -141 -340 -142q-181 0 -291 91q-111 90 -111 239q0 157 121 251q122 95 318 95q133 0 286 -63v67q0 95 -74 157q-75 60 -192 60q-161 0 -289 -102h-16 l-82 125v16q78 64 189 101t219 37q208 0 332 -107q122 -108 122 -317v-625l-14 -12q-15 -15 -35 -40q-21 -25 -33 -47q-23 -38 -26 -91q0 -51 34.5 -84t90.5 -33q38 0 90 24zM502 139q112 0 197 64q85 63 87 159l-2 13v51q-139 70 -264 70q-111 0 -177 -51q-67 -52 -67 -136 q0 -76 62 -123t164 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 1396,
    d: "M559 1571l404 262h16l94 -152v-16l-438 -207h-17l-59 96v17zM788 -25q-296 0 -499 198t-203 493t204 493q205 197 501 197q166 0 309.5 -69t242.5 -193v-19l-143 -114h-16q-147 190 -391 190q-203 0 -340 -137q-138 -136 -138 -348t138 -348q137 -138 340 -138 q244 0 391 191h16l143 -115v-18q-97 -125 -241 -194t-314 -69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 1095,
    d: "M352 1268l387 278h13l100 -153v-13l-420 -225h-14l-66 100v13zM627 -25q-239 0 -394 154q-157 154 -157 383t157 383q155 154 394 154q264 0 417 -181v-16l-126 -113h-19q-111 115 -268 115q-145 0 -238 -97q-94 -97 -94 -247q0 -147 93 -243q93 -97 245 -97 q165 0 262 115h19l126 -113v-16q-153 -181 -417 -181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 1396,
    d: "M793 1481q-59 0 -105 46q-47 47 -47 105q0 63 46 109q47 45 106 45q63 0 108 -45t45 -109q0 -61 -46 -106t-107 -45zM788 -25q-296 0 -499 198t-203 493t204 493q205 197 501 197q166 0 309.5 -69t242.5 -193v-19l-143 -114h-16q-147 190 -391 190q-203 0 -340 -137 q-138 -136 -138 -348t138 -348q137 -138 340 -138q244 0 391 191h16l143 -115v-18q-97 -125 -241 -194t-314 -69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 1095,
    d: "M718 1241q-46 -45 -109 -45q-64 0 -109 46t-45 110q0 63 45 108t109 45q63 0 109 -45t46 -108q0 -66 -46 -111zM627 -25q-239 0 -394 154q-157 154 -157 383t157 383q155 154 394 154q264 0 417 -181v-16l-126 -113h-19q-111 115 -268 115q-145 0 -238 -97 q-94 -97 -94 -247q0 -147 93 -243q93 -97 245 -97q165 0 262 115h19l126 -113v-16q-153 -181 -417 -181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 1396,
    d: "M1157 1679l-354 -202h-21l-352 202v17l64 102h16l285 -139l282 139h15l65 -102v-17zM793 1151q-203 0 -340 -137q-138 -136 -138 -348t138 -348q137 -138 340 -138q244 0 391 191h16l143 -115v-18q-97 -125 -240.5 -194t-314.5 -69q-296 0 -499 198t-203 493t204 493 q205 197 501 197q166 0 309.5 -69t242.5 -193v-19l-143 -114h-16q-147 190 -391 190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 1095,
    d: "M954 1360l-329 -205h-31l-330 205v12l74 105h12l260 -140l258 140h13l73 -105v-12zM631 854q-145 0 -238 -97q-94 -97 -94 -247q0 -147 93 -243q93 -97 245 -97q165 0 262 115h19l126 -113v-16q-154 -179 -417 -181q-239 0 -394 154q-157 154 -157 383t157 383 q155 154 394 154q264 0 417 -181v-16l-126 -113h-19q-109 115 -268 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 1499,
    d: "M1024 1679l-354 -202h-21l-352 202v17l63 102h17l285 -139l282 139h14l66 -102v-17zM174 1331h543q315 0 506 -182q190 -181 190 -481q0 -301 -190 -484q-190 -184 -506 -184h-543v1331zM401 193h312q213 0 341 129q128 130 128 344t-128 344q-128 129 -341 129h-312 v-946z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 1357,
    d: "M1337 1452h185l12 -14l-125 -385l-14 -15h-115l-10 15l53 385zM924 928v444l206 25l17 -13v-1384h-201v131q-141 -156 -354 -156q-224 0 -370 155t-146 382t146 382t370 155q190 0 332 -121zM623 170q137 0 228 90t91 252q0 159 -92 251q-91 91 -227 91q-143 0 -233 -98 q-91 -98 -91 -244t91 -243q90 -99 233 -99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 1517,
    d: "M193 1331h542q315 0 506 -182t191 -481q0 -301 -190 -484q-190 -184 -507 -184h-542v578h-140v180h140v573zM420 193h311q213 0 341 129q128 130 128 344t-128 344q-128 129 -341 129h-311v-381h356v-180h-356v-385z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dslash",
    unicode: "\u0111",
    horizAdvX: 1296,
    d: "M1149 1260h147v-138h-147v-1122h-201v131q-141 -156 -354 -156q-224 0 -370 155t-146 382q0 228 146 383q145 154 370 154q190 0 332 -121v194h-277v138h277v135l207 20l16 -12v-143zM625 170q137 0 227 90t90 252t-90 252t-227 90q-145 0 -234 -98q-90 -99 -90 -244 q0 -146 90 -243q89 -99 234 -99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 1189,
    d: "M326 1503v162h624v-162h-624zM1098 1331v-192h-697v-377h549v-184h-549v-385h699v-193h-926v1331h924z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 1191,
    d: "M297 1391h608v-162h-608v162zM1116 457h-817q12 -144 108 -223q95 -80 228 -80q89 0 177 35q87 34 142 100h19l112 -103v-16q-76 -95 -201 -145q-124 -50 -255 -50q-231 0 -391 147q-160 145 -160 388q0 230 150 385q148 154 378 154q220 0 365 -142q152 -148 151 -379 q0 -44 -6 -71zM602 874q-120 0 -202 -71q-81 -72 -99 -193h600q-17 114 -82 178q-83 86 -217 86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 1189,
    d: "M635 1481q-59 0 -105 46q-47 47 -47 105q0 62 45 109q45 45 107 45q63 0 108 -45t45 -109q0 -61 -46 -106t-107 -45zM1098 1331v-192h-697v-377h549v-184h-549v-385h699v-193h-926v1331h924z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 1191,
    d: "M710 1241q-46 -45 -109 -45q-64 0 -109 46q-46 46 -46 110q0 63 46 108q45 45 109 45q63 0 109 -45t46 -108q0 -66 -46 -111zM1116 457h-817q12 -144 108 -223q95 -80 228 -80q89 0 177 35q87 34 142 100h19l112 -103v-16q-76 -95 -201 -145q-124 -50 -255 -50 q-231 0 -391 147q-160 145 -160 388q0 230 150 385q148 154 378 154q220 0 365 -142q152 -148 151 -379q0 -44 -6 -71zM602 874q-120 0 -202 -71q-81 -72 -99 -193h600q-17 114 -82 178q-83 86 -217 86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 1189,
    d: "M1206 -283l19 -4l43 -94l-2 -16q-85 -49 -183 -49q-115 0 -186 62q-72 62 -72 163q0 120 101 221h-752v1331h924v-192h-697v-377h549v-184h-549v-385h699v-193l-15 -12q-10 -10 -34 -40q-21 -24 -34 -47q-26 -49 -26 -91q0 -51 35 -84t90 -33q38 0 90 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 1191,
    d: "M1116 457h-817q12 -144 108 -223q95 -80 228 -80q89 0 177 35q87 34 142 100h19l112 -103v-16q-85 -111 -245 -162q-104 -104 -105 -186q0 -51 35 -84t90 -33q39 0 90 25l19 -4l43 -95l-2 -16q-85 -49 -183 -49q-115 0 -186 62q-72 63 -72 163q0 99 70 184h-10 q-231 0 -391 147q-160 145 -160 388q0 230 150 385q148 154 378 154q220 0 365 -142q152 -148 151 -379q0 -44 -6 -71zM602 874q-120 0 -202 -71q-81 -72 -99 -193h600q-17 114 -82 178q-83 86 -217 86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 1189,
    d: "M1001 1679l-354 -202h-20l-353 202v17l64 102h16l285 -139l283 139h14l65 -102v-17zM401 578v-385h699v-193h-926v1331h924v-192h-697v-377h549v-184h-549z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 1191,
    d: "M946 1360l-330 -205h-30l-330 205v12l74 105h12l260 -140l258 140h12l74 -105v-12zM1116 457h-817q12 -144 108 -223q95 -80 228 -80q89 0 177 35q87 34 142 100h19l112 -103v-16q-76 -95 -201 -145q-124 -50 -255 -50q-231 0 -391 147q-160 145 -160 388q0 230 150 385 q148 154 378 154q220 0 365 -142q152 -148 151 -379q0 -44 -6 -71zM602 874q-120 0 -202 -71q-81 -72 -99 -193h600q-17 114 -82 178q-83 86 -217 86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 1517,
    d: "M1001 1546q-90 -84 -217 -84q-128 0 -216 84q-90 85 -103 217h164q10 -72 51 -112.5t105 -40.5q63 0 104 41t51 112h164q-13 -132 -103 -217zM1432 739l18 -14q4 -24 4 -78q0 -283 -190 -473q-195 -199 -488 -199q-297 0 -493 196q-197 197 -197 495q0 297 201 494 q199 196 491 196q160 0 307 -68q144 -69 238 -190v-17l-143 -120h-19q-69 89 -168 139.5t-211 50.5q-197 0 -332 -137q-135 -136 -135 -348q0 -213 133 -349q132 -137 332 -137q190 0 324 129q106 107 117 252h-441v178h652z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 1261,
    d: "M844 1268q-90 -84 -223 -84q-134 0 -224 84t-106 217h164q12 -70 57 -112t109 -42q63 0 108 42t57 112h164q-16 -133 -106 -217zM922 911v113h192v-866q0 -241 -149 -366q-149 -124 -379 -124q-152 0 -277.5 56t-204.5 155v19l111 114h16q129 -168 355 -168q140 0 228 73 q89 74 89 212v78q-135 -123 -330 -123q-216 0 -355 138q-140 138 -140 345q0 205 141 344q141 138 356 138q209 0 347 -138zM608 262q136 0 221 85q86 86 86 218q0 133 -86 219t-223 86q-135 0 -220 -85t-85 -218q0 -135 85 -220t222 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 1517,
    d: "M780 1483q-59 0 -105 46t-46 105q0 62 46 108t105 46q62 0 109 -45q45 -45 45 -109q0 -61 -46 -106t-108 -45zM1432 739l18 -14q4 -24 4 -78q0 -283 -190 -473q-195 -199 -488 -199q-297 0 -493 196q-197 197 -197 495q0 297 201 494q199 196 491 196q160 0 307 -68 q144 -69 238 -190v-17l-143 -120h-19q-69 89 -168 139.5t-211 50.5q-197 0 -332 -137q-135 -136 -135 -348q0 -213 133 -349q132 -137 332 -137q190 0 324 129q106 107 117 252h-441v178h652z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 1261,
    d: "M618 1196q-63 0 -108 46t-45 110q0 63 45 108t109 45q63 0 109 -45t46 -108q0 -66 -45 -111t-111 -45zM922 911v113h192v-866q0 -241 -149 -366q-149 -124 -379 -124q-152 0 -277.5 56t-204.5 155v19l111 114h16q129 -168 355 -168q140 0 228 73q89 74 89 212v78 q-135 -123 -330 -123q-216 0 -355 138q-140 138 -140 345q0 205 141 344q141 138 356 138q209 0 347 -138zM608 262q136 0 221 85q86 86 86 218q0 133 -86 219t-223 86q-135 0 -220 -85t-85 -218q0 -135 85 -220t222 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0122",
    unicode: "\u0122",
    horizAdvX: 1517,
    d: "M1432 739l18 -14q4 -24 4 -78q0 -283 -190 -473q-195 -199 -488 -199q-297 0 -493 196q-197 197 -197 495q0 297 201 494q199 196 491 196q160 0 307 -68q144 -69 238 -190v-17l-143 -120h-19q-69 89 -168 139.5t-211 50.5q-197 0 -332 -137q-135 -136 -135 -348 q0 -213 133 -349q132 -137 332 -137q190 0 324 129q106 107 117 252h-441v178h652zM623 -479l49 358l14 15h178l13 -15l-113 -358l-14 -15h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0123",
    unicode: "\u0123",
    horizAdvX: 1261,
    d: "M725 1169l-14 -14h-179l-12 14l113 359l14 14h115l12 -14zM922 911v113h192v-866q0 -241 -149 -366q-149 -124 -379 -124q-152 0 -277.5 56t-204.5 155v19l111 114h16q129 -168 355 -168q140 0 228 73q89 74 89 212v78q-135 -123 -330 -123q-216 0 -355 138 q-140 138 -140 345q0 205 141 344q141 138 356 138q209 0 347 -138zM608 262q136 0 221 85q86 86 86 218q0 133 -86 219t-223 86q-135 0 -220 -85t-85 -218q0 -135 85 -220t222 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 1490,
    d: "M1311 1116h108v-149h-108v-969h-228v573h-673v-573h-228v969h-110v149h110v213h228v-213h673v213h228v-213zM410 764h673v203h-673v-203z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 1232,
    d: "M369 1118v-196q115 127 307 127q190 0 306 -120q116 -121 116 -313v-616h-224v600q0 116 -66 187q-68 69 -181 69q-115 0 -186 -69q-72 -71 -72 -187v-600h-222v1118h-149v139h149v134l205 24l17 -12v-146h284v-139h-284z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 575,
    d: "M436 1505q-57 0 -156 39q-100 39 -149 39q-41 0 -73.5 -20.5t-47.5 -55.5h-8l-12 11v157q41 84 149 84q55 0 159 -39t144 -39q93 0 121 76h8l15 -10v-158q-48 -84 -150 -84zM174 0v1331h227v-1331h-227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 524,
    d: "M401 1217q-50 0 -144 38q-92 37 -140 37q-102 0 -133 -73h-13l-10 10v145q49 84 158 84q54 0 150 -37q95 -37 132 -37q103 0 138 72h8l12 -8v-148q-50 -83 -158 -83zM373 0h-221v1024h221v-1024z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 575,
    d: "M8 1503v162h561v-162h-561zM174 0v1331h227v-1331h-227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 524,
    d: "M-20 1229v162h565v-162h-565zM373 0h-221v1024h221v-1024z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 575,
    d: "M508 -283l18 -4l43 -94l-2 -16q-85 -49 -182 -49q-115 0 -186 62q-72 62 -72 163q0 121 100 221h-53v1331h227v-1331l-14 -12q-10 -10 -34 -40q-21 -24 -34 -47q-21 -35 -26 -91q0 -51 34.5 -84t90.5 -33q38 0 90 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 524,
    d: "M262 1196q-63 0 -108 46t-45 110q0 63 45 108t109 45q63 0 109 -45t46 -108q0 -66 -45 -111t-111 -45zM479 -283l19 -4l43 -94l-2 -16q-85 -49 -183 -49q-115 0 -186 62q-72 62 -72 163q0 120 101 221h-47v1024h221v-1024l-15 -12q-10 -10 -34 -40q-21 -24 -34 -47 q-26 -49 -26 -91q0 -51 35 -84t90 -33q37 0 90 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idot",
    unicode: "\u0130",
    horizAdvX: 575,
    d: "M287 1481q-59 0 -105 46q-47 47 -47 105q0 62 45 109q45 45 107 45q63 0 108 -45t45 -109q0 -61 -46 -106q-47 -45 -107 -45zM174 0v1331h227v-1331h-227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 524,
    d: "M373 0h-221v1024h221v-1024z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 1509,
    d: "M174 0v1331h227v-1331h-227zM1124 436v895h228v-870q0 -243 -121 -364q-122 -122 -322 -122q-270 0 -417 205v19l135 127h18q97 -144 252 -146q99 0 164 68q63 68 63 188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 1036,
    d: "M371 1241q-45 -45 -108 -45q-64 0 -109 46t-45 110q0 63 45 108t109 45q63 0 108 -45t45 -108q0 -66 -45 -111zM885 1241q-45 -45 -108 -45q-64 0 -109 46t-45 110q0 63 45 108t109 45q63 0 108 -45t45 -108q0 -66 -45 -111zM373 0h-221v1024h221v-1024zM618 -340h-16 l-82 162v16q83 45 115 99q31 55 31 169v918h223v-920q0 -184 -58 -278t-213 -166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0136",
    unicode: "\u0136",
    horizAdvX: 1271,
    d: "M1251 1313l-557 -586l570 -709l-11 -18h-247l-476 588l-129 -137v-451h-227v1331h227v-614l586 614h254zM594 -121l14 15h178l13 -15l-113 -358l-14 -15h-115l-12 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0137",
    unicode: "\u0137",
    horizAdvX: 1089,
    d: "M1069 1008l-420 -443l432 -549l-8 -16h-246l-342 444l-114 -120v-324h-224v1372l207 25l17 -13v-841l446 481h242zM502 -121l14 15h178l13 -15l-113 -358l-14 -15h-115l-12 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 1089,
    d: "M1069 1008l-420 -443l432 -549l-8 -16h-246l-342 444l-114 -120v-324h-224v1024h224v-481l446 481h242z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 1042,
    d: "M31 1571l403 262h17l94 -152v-16l-439 -207h-16l-59 96v17zM401 193h615v-193h-842v1331h227v-1138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 524,
    d: "M-6 1569l403 262h17l94 -152v-16l-438 -207h-17l-59 96v17zM373 0h-221v1372l204 25l17 -13v-1384z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013B",
    unicode: "\u013B",
    horizAdvX: 1042,
    d: "M401 193h615v-193h-842v1331h227v-1138zM442 -479l50 358l14 15h178l12 -15l-112 -358l-15 -15h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013C",
    unicode: "\u013C",
    horizAdvX: 524,
    d: "M373 0h-221v1372l204 25l17 -13v-1384zM111 -479l49 358l14 15h178l13 -15l-113 -358l-14 -15h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 1046,
    d: "M565 1053l53 387l17 12h182l12 -12l-122 -387l-17 -13h-112zM401 193h615v-193h-842v1331h227v-1138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 581,
    d: "M494 1053l53 385l16 14h185l10 -14l-123 -385l-17 -15h-112zM373 0h-221v1372l204 25l17 -13v-1384z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 1062,
    d: "M401 193h615v-193h-842v1331h227v-1138zM892 613q-42 -42 -101 -42q-61 0 -101 42q-41 43 -41 102t42 100q43 41 100 41q58 0 101 -41q42 -40 42 -100t-42 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 655,
    d: "M373 0h-221v1372l204 25l17 -13v-1384zM590 565q-59 0 -102 43q-44 44 -44 103t43 102t103 43q61 0 103 -43t42 -102t-42 -103q-42 -43 -103 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 1120,
    d: "M477 586v-393h615v-193h-842v477l-178 -84l-17 10v179l195 92v657h227v-549l266 127l17 -10v-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 702,
    d: "M631 944l16 -10v-160l-184 -96v-678h-223v563l-166 -86l-19 8v160l185 96v631l206 25l17 -13v-528z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    d: "M1016 1665l-438 -207h-17l-59 96v17l403 262h17l94 -152v-16zM1077 397v934h223v-1345h-126l-777 936v-922h-223v1331h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 1234,
    d: "M897 1380l-420 -225h-14l-66 100v13l387 278h13l100 -153v-13zM678 1049q194 0 309 -120q115 -119 115 -313v-616h-225v598q0 119 -67 189q-67 69 -181 69t-184 -70q-72 -70 -72 -188v-598h-226v1024h197v-133q122 158 334 158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0145",
    unicode: "\u0145",
    d: "M1077 397v934h223v-1345h-126l-777 936v-922h-223v1331h127zM625 -121l14 15h178l12 -15l-112 -358l-15 -15h-114l-13 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0146",
    unicode: "\u0146",
    horizAdvX: 1234,
    d: "M678 1049q194 0 309 -120q115 -119 115 -313v-616h-225v598q0 119 -67 189q-67 69 -181 69t-184 -70q-72 -70 -72 -188v-598h-226v1024h197v-133q122 158 334 158zM518 -121l14 15h179l12 -15l-113 -358l-14 -15h-115l-12 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    d: "M1100 1679l-355 -202h-20l-352 202v17l63 102h17l284 -139l283 139h14l66 -102v-17zM1077 397v934h223v-1345h-126l-777 936v-922h-223v1331h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 1234,
    d: "M999 1360l-329 -205h-31l-330 205v12l74 105h12l260 -140l258 140h13l73 -105v-12zM678 1049q194 0 309 -120q115 -119 115 -313v-616h-225v598q0 119 -67 189q-67 69 -181 69t-184 -70q-72 -70 -72 -188v-598h-226v1024h197v-133q122 158 334 158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 1239,
    d: "M352 1528l-119 -361l-16 -12h-115l-12 12l51 361l17 12h184zM682 1049q194 0 309 -120q115 -119 115 -313v-616h-225v598q0 119 -66.5 188.5t-181.5 69.5q-114 0 -184 -70q-72 -70 -72 -188v-598h-225v1024h196v-133q122 158 334 158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    d: "M1077 383v948h223v-1397q0 -178 -118 -287q-118 -108 -291 -108q-105 0 -205 41q-99 40 -154 119v18l132 119h16q33 -48 90.5 -77t120.5 -29q93 0 148 60q55 59 55 155v139l-697 840v-924h-223v1331h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 1234,
    d: "M678 1049q190 0 307 -120t117 -313v-473q0 -180 -67 -289q-68 -109 -216 -173h-16l-72 153v16q83 44 114 104q32 62 32 181v463q0 119 -67 189q-67 69 -181 69t-184 -70q-72 -70 -72 -188v-598h-226v1024h197v-133q122 158 334 158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 1597,
    d: "M487 1503v162h625v-162h-625zM1309 173q-205 -198 -510 -198t-510 198t-205 493t205 493q206 197 510 197t510 -197q204 -198 204 -493t-204 -493zM454 318q138 -138 345 -138t346 138q139 136 139 348t-139 348q-140 137 -346 137t-345 -137q-139 -136 -139 -348 t139 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 1259,
    d: "M326 1229v162h608v-162h-608zM629 -25q-238 0 -395 154q-158 155 -158 383t158 383q157 154 395 154q241 0 398 -154t157 -383t-157 -383t-398 -154zM629 170q144 0 239 98q93 98 93 244q0 148 -93 245q-94 97 -239 97q-143 0 -236 -97q-94 -97 -94 -245q0 -147 94 -244 q93 -98 236 -98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 1597,
    d: "M514 1470l184 324h199l10 -16l-239 -322h-146zM858 1470l186 324h197l10 -16l-239 -322h-146zM1309 173q-205 -198 -510 -198t-510 198t-205 493t205 493q206 197 510 197t510 -197q204 -198 204 -493t-204 -493zM454 318q138 -138 345 -138t346 138q139 136 139 348 t-139 348q-140 137 -346 137t-345 -137q-139 -136 -139 -348t139 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 1259,
    d: "M381 1167l137 353l19 14h176l10 -14l-205 -353l-16 -14h-109zM692 1167l137 353l19 14h176l10 -14l-205 -353l-16 -14h-108zM629 -25q-238 0 -395 154q-158 155 -158 383t158 383q157 154 395 154q241 0 398 -154t157 -383t-157 -383t-398 -154zM629 170q144 0 239 98 q93 98 93 244q0 148 -93 245q-94 97 -239 97q-143 0 -236 -97q-94 -97 -94 -245q0 -147 94 -244q93 -98 236 -98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 2299,
    d: "M1511 578v-385h699v-193h-926v176q-201 -201 -491 -201q-301 0 -505 198t-204 493t204 493q205 197 505 197q288 0 491 -203v178h924v-192h-697v-377h549v-184h-549zM454 318q138 -138 345 -138t346 138q139 136 139 348t-139 348q-140 137 -346 137t-345 -137 q-139 -136 -139 -348t139 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 2074,
    d: "M2005 528q0 -39 -4 -71h-819q12 -143 107 -223t229 -80q88 0 178 35q89 35 141 100h18l113 -103v-16q-76 -96 -202 -145q-124 -50 -255 -50q-136 0 -251.5 52.5t-190.5 150.5q-161 -203 -440 -203q-238 0 -395 154q-158 155 -158 383t158 383q157 154 395 154 q281 0 440 -203q52 71 135 121q127 82 285 82q244 0 393 -170q123 -145 123 -351zM1184 598h604q-6 110 -74 184q-83 92 -229 92q-115 0 -191 -61q-98 -78 -110 -215zM629 170q144 0 239 98q93 98 93 244q0 148 -93 245q-94 97 -239 97q-143 0 -236 -97q-94 -97 -94 -245 q0 -147 94 -244q93 -98 236 -98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 1296,
    d: "M905 1665l-438 -207h-16l-60 96v17l404 262h16l94 -152v-16zM915 561l291 -543l-10 -18h-223l-285 535h-287v-535h-227v1331h535q236 0 362.5 -106t126.5 -297q0 -136 -73.5 -230.5t-209.5 -136.5zM729 1139h-328v-437h328q110 0 174 61q64 60 64 159q0 98 -64 158 q-65 59 -174 59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 782,
    d: "M709 1380l-420 -225h-15l-65 100v13l387 278h12l101 -153v-13zM774 1016l10 -17l-55 -163l-18 -9q-38 25 -113 25q-102 0 -164 -80q-63 -80 -63 -205v-567h-224v1024h197v-135q100 160 277 160q85 0 153 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0156",
    unicode: "\u0156",
    horizAdvX: 1296,
    d: "M915 561l291 -543l-10 -18h-223l-285 535h-287v-535h-227v1331h535q236 0 362.5 -106t126.5 -297q0 -136 -73.5 -230.5t-209.5 -136.5zM729 1139h-328v-437h328q110 0 174 61q64 60 64 159q0 98 -64 158q-65 59 -174 59zM551 -121l14 15h178l13 -15l-113 -358l-14 -15 h-115l-12 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0157",
    unicode: "\u0157",
    horizAdvX: 782,
    d: "M774 1016l10 -17l-55 -163l-18 -9q-38 25 -113 25q-102 0 -164 -80q-63 -80 -63 -205v-567h-224v1024h197v-135q100 160 277 160q85 0 153 -33zM156 -121l14 15h178l12 -15l-112 -358l-15 -15h-114l-13 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 1296,
    d: "M989 1679l-354 -202h-21l-352 202v17l64 102h16l285 -139l282 139h15l65 -102v-17zM915 561l291 -543l-10 -18h-223l-285 535h-287v-535h-227v1331h535q236 0 362.5 -106t126.5 -297q0 -136 -73.5 -230.5t-209.5 -136.5zM729 1139h-328v-437h328q110 0 174 61 q64 60 64 159q0 98 -64 158q-65 59 -174 59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 782,
    d: "M725 1477h12l74 -105v-12l-330 -205h-30l-330 205v12l74 105h12l260 -140zM621 1049q85 0 153 -33l10 -17l-55 -163l-18 -9q-38 25 -113 25q-102 0 -164 -80q-63 -80 -63 -205v-567h-224v1024h197v-135q100 160 277 160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 1169,
    d: "M360 1571l404 262h16l94 -152v-16l-438 -207h-16l-60 96v17zM600 -25q-165 0 -310 68q-144 67 -233 186v19l123 127h19q72 -92 178 -147q107 -56 209 -56q122 0 196 51q72 51 72 133q0 72 -51 121q-20 19 -62 39q-34 16 -72 29q-51 17 -89 30q-45 15 -95 31 q-79 29 -125 52q-49 23 -111 68q-124 90 -124 257q0 164 129 269q130 104 336 104q149 0 271 -54.5t196 -148.5v-18l-121 -127h-16q-136 158 -326 157q-104 0 -171 -46t-67 -122q0 -53 37 -93t78 -58q29 -14 121 -47q12 -5 75 -24q71 -24 80 -28q21 -10 71 -29 q56 -23 75 -37q23 -18 60 -41q13 -9 24 -18t18 -15.5t16 -19.5t12.5 -17.5t13.5 -21t13 -21.5q37 -61 37 -167q0 -176 -137 -280q-136 -105 -350 -105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 940,
    d: "M221 1268l387 278h13l100 -153v-13l-420 -225h-14l-66 100v13zM471 -27q-130 0 -240.5 50t-179.5 139v16l113 113h18q45 -60 122 -98q80 -39 163 -39q78 0 127 33.5t49 86.5q0 44 -40 91q-14 14 -49 33q-20 10 -53 25q-6 3 -28.5 11.5t-38.5 14.5q-71 26 -119 48 q-44 20 -97 55q-105 70 -105 204q0 133 101 214q100 81 271 81q112 0 215 -47q102 -49 154 -123v-19l-113 -108h-16q-98 122 -244 120q-68 0 -109.5 -29.5t-41.5 -76.5q0 -46 42 -75q46 -31 142 -70l21 -9q86 -35 128 -57q50 -26 97 -62q100 -75 100 -223q0 -133 -107 -216 q-109 -83 -282 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u015E",
    horizAdvX: 1169,
    d: "M1087 360q0 -160 -113 -262q-113 -101 -298 -118l-21 -68q116 0 179 -52t63 -145q0 -102 -77 -165q-77 -62 -202 -62q-153 0 -260 82v16l60 90h18q76 -51 162 -51q127 0 127 88q0 67 -73 86q-75 21 -163 -4l-36 23l53 164q-292 38 -449 247v19l123 127h19 q72 -92 178 -147q107 -56 209 -56q122 0 196 51q72 51 72 133q0 72 -51 121q-20 19 -62 39q-34 16 -72 29q-51 17 -89 30q-45 15 -95 31q-79 29 -125 52q-49 23 -111 68q-124 90 -124 257q0 164 129 269q130 104 336 104q149 0 271 -54.5t196 -148.5v-18l-121 -127h-16 q-136 158 -326 157q-104 0 -171 -46t-67 -122q0 -53 37 -93t78 -58q29 -14 121 -47q12 -5 75 -24q71 -24 80 -28q21 -10 71 -29q56 -23 75 -37q23 -18 60 -41q13 -9 24 -18t18 -15.5t16 -19.5t12.5 -17.5t13.5 -21t13 -21.5q37 -61 37 -167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u015F",
    horizAdvX: 940,
    d: "M860 272q0 -116 -84 -196t-225 -99l-21 -65q116 0 179 -52t63 -145q0 -102 -77 -165q-77 -62 -201 -62q-152 0 -261 82v16l60 90h18q77 -51 162 -51q127 0 127 88q0 67 -73 86q-74 21 -162 -4l-37 23l51 162q-212 33 -328 182v16l113 113h18q45 -60 122 -98 q80 -39 163 -39q78 0 127 33.5t49 86.5q0 44 -40 91q-14 14 -49 33q-20 10 -53 25q-6 3 -28.5 11.5t-38.5 14.5q-71 26 -119 48q-44 20 -97 55q-105 70 -105 204q0 133 101 214q100 81 271 81q112 0 215 -47q102 -49 154 -123v-19l-113 -108h-16q-98 122 -244 120 q-68 0 -109.5 -29.5t-41.5 -76.5q0 -46 42 -75q46 -31 142 -70l21 -9q86 -35 128 -57q50 -26 97 -62q100 -75 100 -223z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 1169,
    d: "M961 1679l-355 -202h-20l-353 202v17l64 102h16l285 -139l283 139h14l66 -102v-17zM592 799q12 -5 75 -24q71 -24 80 -28q21 -10 71 -29q56 -23 75 -37q23 -18 60 -41q13 -9 24 -18t18 -15.5t16 -19.5t12.5 -17.5t13.5 -21t13 -21.5q37 -61 37 -167q0 -176 -137 -280 q-136 -105 -350 -105q-165 0 -310 68q-144 67 -233 186v19l123 127h19q72 -92 178 -147q107 -56 209 -56q122 0 196 51q72 51 72 133q0 72 -51 121q-20 19 -62 39q-34 16 -72 29q-51 17 -89 30q-45 15 -95 31q-79 29 -125 52q-49 23 -111 68q-124 90 -124 257q0 164 129 269 q130 104 336 104q149 0 271 -54.5t196 -148.5v-18l-121 -127h-16q-136 158 -326 157q-104 0 -171 -46t-67 -122q0 -53 37 -93t78 -58q42 -19 121 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 940,
    d: "M823 1360l-329 -205h-31l-330 205v12l74 105h12l260 -140l258 140h13l73 -105v-12zM535 614q86 -35 128 -57q50 -26 97 -62q100 -75 100 -223q0 -133 -107 -216q-109 -83 -282 -83q-130 0 -240.5 50t-179.5 139v16l113 113h18q45 -60 122 -98q80 -39 163 -39 q78 0 127 33.5t49 86.5q0 44 -40 91q-14 14 -49 33q-20 10 -53 25q-6 3 -28.5 11.5t-38.5 14.5q-71 26 -119 48q-44 20 -97 55q-105 70 -105 204q0 133 101 214q100 81 271 81q112 0 215 -47q102 -49 154 -123v-19l-113 -108h-16q-98 122 -244 120q-68 0 -109.5 -29.5 t-41.5 -76.5q0 -46 42 -75q46 -31 142 -70q15 -7 21 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 1140,
    d: "M684 1139v-1139h-27l-26 -88q116 0 178.5 -52t62.5 -145q0 -102 -76 -165q-77 -62 -202 -62q-153 0 -260 82v16l59 90h19q76 -51 161 -51q127 0 127 88q0 67 -73 86q-74 21 -162 -4l-37 23l57 182h-28v1139h-430v192h1087v-192h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 798,
    d: "M580 -23l-19 -65q116 0 179 -52t63 -145q0 -102 -77 -165q-77 -62 -202 -62q-153 0 -260 82v16l60 90h18q76 -51 162 -51q127 0 127 88q0 66 -74 86q-74 21 -162 -4l-37 23l58 180q-205 73 -205 328v524h-174v174h174v309l207 25l16 -12v-322h311v-174h-311v-510 q0 -172 146 -172q69 0 116 47l19 -8l65 -137l-6 -19q-80 -64 -194 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 1140,
    d: "M934 1679l-354 -202h-21l-352 202v17l63 102h17l284 -139l283 139h14l66 -102v-17zM27 1139v192h1087v-192h-430v-1139h-227v1139h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 798,
    d: "M664 1155l-17 -12h-112l-13 12l53 387l17 12h182l12 -12zM696 215l19 -8l65 -137l-6 -19q-95 -76 -225 -76q-150 0 -244 91q-94 90 -94 260v524h-174v174h174v309l207 25l16 -12v-322h311v-174h-311v-510q0 -172 146 -172q69 0 116 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 1167,
    d: "M1126 1331v-192h-430v-432h226v-150h-226v-557h-227v557h-229v150h229v432h-430v192h1087z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 813,
    d: "M709 215l18 -8l66 -137l-7 -19q-95 -76 -225 -76q-150 0 -244 91q-94 90 -94 260v149h-172v137h172v238h-174v174h174v309l207 25l16 -12v-322h312v-174h-312v-238h248v-137h-248v-135q0 -172 146 -172q70 0 117 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    d: "M913 1505q-65 0 -181 39t-171 39q-104 0 -141 -76h-10l-15 11v157q49 84 174 84q63 0 183 -39t170 -39q109 0 139 76h10l16 -10v-158q-51 -84 -174 -84zM156 553v778h227v-782q0 -167 99 -267q98 -102 260 -102q161 0 260 102q98 101 98 267v782h221v-778 q0 -259 -158 -419q-159 -159 -422 -159t-424 159t-161 419z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 1208,
    d: "M299 1219h-12l-13 10v145q51 84 170 84q60 0 162 -37t142 -37q116 0 147 72h10l13 -8v-148q-51 -85 -170 -83q-54 0 -154 38q-99 37 -152 37q-110 2 -143 -73zM838 426v598h223v-1024h-197v123q-112 -146 -317 -148q-184 0 -298 119q-114 118 -114 314v616h223v-608 q0 -112 64 -179q63 -69 170 -69q112 0 180 71q66 70 66 187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    d: "M428 1503v162h625v-162h-625zM156 553v778h227v-782q0 -167 99 -267q98 -102 260 -102q161 0 260 102q98 101 98 267v782h221v-778q0 -259 -158 -419q-159 -159 -422 -159t-424 159t-161 419z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 1208,
    d: "M293 1391h608v-162h-608v162zM838 426v598h223v-1024h-197v123q-112 -146 -317 -148q-184 0 -298 119q-114 118 -114 314v616h223v-608q0 -112 64 -179q63 -69 170 -69q112 0 180 71q66 70 66 187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    d: "M901 1503q-68 -65 -159 -65q-92 0 -159 65q-67 64 -67 156q0 93 67 157q65 64 159 64q92 0 159 -64q66 -64 66 -157q0 -91 -66 -156zM678 1594q19 -22 46.5 -26t51 6.5t40 33.5t15.5 51q0 37 -27.5 64.5t-62.5 27.5q-37 0 -63.5 -27.5t-26.5 -64.5q0 -39 27 -65zM156 553 v778h227v-782q0 -167 99 -267q98 -102 260 -102q161 0 260 102q98 101 98 267v782h221v-778q0 -259 -158 -419q-159 -159 -422 -159t-424 159t-161 419z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 1208,
    d: "M598 1124q-98 0 -163 65q-66 65 -66 157t66 158q65 65 163 65q95 0 162 -65q65 -67 65 -158q0 -90 -66 -156q-67 -66 -161 -66zM659 1408q-24 24 -61 24t-61 -25q-25 -25 -25 -61q0 -35 24.5 -59.5t61.5 -24.5q36 0 60 24t24 60t-23 62zM838 426v598h223v-1024h-197v123 q-112 -146 -317 -148q-184 0 -298 119q-114 118 -114 314v616h223v-608q0 -112 64 -179q63 -69 170 -69q112 0 180 71q66 70 66 187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    d: "M455 1470l184 324h199l10 -16l-240 -322h-145zM799 1470l186 324h197l10 -16l-240 -322h-145zM156 553v778h227v-782q0 -167 99 -267q98 -102 260 -102q161 0 260 102q98 101 98 267v782h221v-778q0 -259 -158 -419q-159 -159 -422 -159t-424 159t-161 419z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 1208,
    d: "M485 1167l-16 -14h-109l-12 14l137 353l19 14h176l10 -14zM780 1153h-108l-13 14l138 353l18 14h176l10 -14l-204 -353zM838 426v598h223v-1024h-197v123q-112 -146 -317 -148q-184 0 -298 119q-114 118 -114 314v616h223v-608q0 -112 64 -179q63 -69 170 -69 q112 0 180 71q66 70 66 187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    d: "M1026 37q-98 -92 -98 -180q0 -51 34.5 -84t90.5 -33q37 0 90 24l18 -4l43 -94l-2 -16q-85 -49 -182 -49q-115 0 -186 62q-72 63 -72 163q0 80 47 151q-30 -2 -68 -2q-263 0 -424 159t-161 419v778h227v-782q0 -167 99 -267q98 -102 260 -102q161 0 260 102q98 101 98 267 v782h221v-778q0 -179 -77.5 -313t-217.5 -203z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 1208,
    d: "M1167 -283l19 -4l43 -94l-2 -16q-85 -49 -183 -49q-115 0 -186 62q-72 62 -72 163q0 120 101 221h-23v123q-112 -146 -317 -148q-184 0 -298 119q-114 118 -114 314v616h223v-608q0 -112 64 -179q63 -69 170 -69q112 0 180 71q66 70 66 187v598h223v-1024l-14 -12 q-15 -15 -35 -40q-21 -24 -34 -47q-22 -41 -26 -91q0 -51 35 -84t90 -33q37 0 90 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 1947,
    d: "M971 1618l-283 -137h-16l-68 108v17l357 200h20l356 -200v-17l-67 -108h-17zM1694 1331h217l10 -18l-489 -1313h-121l-338 934l-334 -934h-123l-487 1313l10 18h229l320 -936l325 936h121l332 -946z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 1593,
    d: "M797 1307l-260 -138h-13l-73 103v14l329 205h31l330 -205v-14l-74 -103h-12zM1350 1024h211l10 -16l-375 -1008h-141l-260 692l-260 -692h-140l-368 1008l10 16h215l225 -717l260 717h119l260 -709z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 1323,
    d: "M659 1618l-282 -137h-17l-67 108v17l356 200h21l356 -200v-17l-68 -108h-16zM1270 1331l10 -18l-504 -813v-500h-227v498l-514 815l10 18h227l394 -643l383 643h221z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 1085,
    d: "M557 1307l-260 -138h-12l-74 103v14l330 205h30l330 -205v-14l-74 -103h-12zM852 1024h201l12 -16l-475 -1086q-63 -140 -137 -198q-74 -56 -185 -56q-101 0 -168 41l-8 19l49 139l19 6q40 -27 100 -27q46 0 76.5 23t56.5 86l51 111l-417 942l12 16h221l297 -729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 1323,
    d: "M444 1481q-63 0 -107 44t-44 105q0 62 44 108q44 44 107 44q60 0 106 -44q44 -44 44 -108q0 -61 -44 -105q-46 -44 -106 -44zM993 1525q-46 -44 -106 -44q-62 0 -106 44t-44 105q0 62 44 108q44 44 106 44q60 0 106 -44q45 -44 45 -108q0 -62 -45 -105zM1270 1331l10 -18 l-504 -813v-500h-227v498l-514 815l10 18h227l394 -643l383 643h221z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 1187,
    d: "M874 1665l-438 -207h-16l-60 96v17l404 262h16l94 -152v-16zM1096 1198l-738 -1012h777v-186h-1078v133l742 1012h-705v186h1002v-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 995,
    d: "M246 1268l387 278h12l100 -153v-13l-419 -225h-15l-65 100v13zM936 0h-868v156l569 698h-549v170h815v-156l-559 -698h592v-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 1187,
    d: "M594 1481q-59 0 -105 46q-47 47 -47 105q0 62 45 109q45 45 107 45t109 -45q45 -45 45 -109q0 -61 -46 -106t-108 -45zM1096 1198l-738 -1012h777v-186h-1078v133l742 1012h-705v186h1002v-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 995,
    d: "M611 1241q-47 -45 -109 -45q-64 0 -109 46t-45 110q0 63 45 108t109 45q62 0 109 -45q46 -45 46 -108q0 -66 -46 -111zM936 0h-868v156l569 698h-549v170h815v-156l-559 -698h592v-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 1187,
    d: "M958 1679l-354 -202h-20l-353 202v17l64 102h16l285 -139l283 139h14l65 -102v-17zM1096 1198l-738 -1012h777v-186h-1078v133l742 1012h-705v186h1002v-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 995,
    d: "M848 1360l-330 -205h-31l-329 205v12l73 105h13l260 -140l258 140h12l74 -105v-12zM903 868l-559 -698h592v-170h-868v156l569 698h-549v170h815v-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01EA",
    unicode: "\u01EA",
    horizAdvX: 1597,
    d: "M1098 35l-15 -15q-15 -15 -35 -37q-14 -15 -33 -48q-26 -43 -26 -91q0 -51 35 -83.5t90 -32.5q38 0 90 24l19 -4l43 -94l-2 -16q-84 -48 -183 -50q-115 0 -186 62q-72 63 -72 164q0 87 56 166q-18 -2 -80 -5q-305 0 -510 198t-205 493t205 493q206 197 510 197t510 -197 q204 -198 204 -493q0 -214 -113 -383q-114 -168 -302 -248zM454 1014q-139 -136 -139 -348t139 -348q138 -138 345 -138t346 138q139 136 139 348t-139 348q-140 137 -346 137t-345 -137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01EB",
    unicode: "\u01EB",
    horizAdvX: 1259,
    d: "M817 4q-102 -96 -102 -184q0 -51 34.5 -84t90.5 -33q39 0 90 25l18 -4l43 -95l-2 -16q-85 -49 -182 -49q-115 0 -186 62q-72 63 -72 163q0 96 69 186q-231 1 -387 157q-155 155 -155 380q0 228 158 383q157 154 395 154q241 0 398 -154t157 -383q0 -180 -100 -316 t-267 -192zM393 757q-94 -97 -94 -245q0 -146 93 -244t237 -98t239 98q93 98 93 244q0 148 -93 245q-94 97 -239 97q-143 0 -236 -97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 2007,
    d: "M1704 1665l-438 -207h-17l-59 96v17l403 262h17l94 -152v-16zM1219 578v-385h698v-193h-926v270h-579l-189 -270h-241l-9 18l928 1313h1014v-192h-696v-377h548v-184h-548zM991 1098l-459 -656h459v656z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 1910,
    d: "M1192 1380l-420 -225h-14l-66 100v13l387 278h13l100 -153v-13zM1835 457h-817q12 -144 108 -223q95 -80 228 -80q89 0 177 35q87 34 142 100h19l112 -103v-16q-76 -95 -201 -145q-124 -50 -255 -50q-139 0 -259.5 57.5t-195.5 162.5q-66 -99 -184 -160 q-117 -60 -248 -60q-181 0 -291 91q-111 90 -111 239q0 157 121 251q122 95 318 95q139 0 286 -63v67q0 95 -74 157q-75 60 -192 60q-167 0 -289 -100h-16l-82 125v16q75 62 189 100q112 36 219 36q277 0 389 -175q151 173 397 175q220 0 365 -142q152 -148 151 -379 q0 -44 -6 -71zM1321 874q-120 0 -202 -71q-81 -72 -99 -193h600q-17 114 -82 178q-83 86 -217 86zM502 139q111 0 198 78q86 78 86 178v31q-139 70 -266 70q-109 0 -175 -51q-66 -53 -66 -136q0 -76 62 -123t161 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 1597,
    d: "M1077 1665l-438 -207h-16l-60 96v17l404 262h16l94 -152v-16zM1427 1442l-161 -244q118 -97 182.5 -234.5t64.5 -297.5q0 -295 -204 -493q-205 -198 -510 -198q-158 0 -305 62l-97 -146h-211l-10 19l152 227q-244 201 -244 529q0 295 205 493q206 197 510 197 q160 0 301 -60l108 164h209zM315 666q0 -205 136 -344l530 796q-89 33 -182 33q-206 0 -345 -137q-139 -136 -139 -348zM799 180q207 0 346 138q139 136 139 348q0 214 -141 350l-531 -801q90 -35 187 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    horizAdvX: 1259,
    d: "M874 1380l-419 -225h-15l-65 100v13l387 278h12l100 -153v-13zM1176 1130l-158 -227q166 -154 166 -391q0 -228 -158 -383q-157 -154 -397 -154q-127 0 -226 43l-81 -116h-207l-11 18l140 199q-168 157 -168 393q0 228 158 383q157 154 395 154q123 0 231 -45l101 145 h204zM299 512q0 -124 68 -215l374 539q-52 18 -112 18q-143 0 -236 -97q-94 -97 -94 -245zM629 170q144 0 239 98q93 98 93 244q0 122 -66 213l-375 -539q52 -16 109 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 1169,
    d: "M600 -25q-165 0 -310 68q-144 67 -233 186v19l123 127h19q72 -92 178 -147q107 -56 209 -56q122 0 196 51q72 51 72 133q0 72 -51 121q-20 19 -62 39q-34 16 -72 29q-51 17 -89 30q-45 15 -95 31q-79 29 -125 52q-49 23 -111 68q-124 90 -124 257q0 164 129 269 q130 104 336 104q149 0 271 -54.5t196 -148.5v-18l-121 -127h-16q-136 158 -326 157q-104 0 -171 -46t-67 -122q0 -53 37 -93t78 -58q29 -14 121 -47q12 -5 75 -24q71 -24 80 -28q21 -10 71 -29q56 -23 75 -37q23 -18 60 -41q13 -9 24 -18t18 -15.5t16 -19.5t12.5 -17.5 t13.5 -21t13 -21.5q37 -61 37 -167q0 -176 -137 -280q-136 -105 -350 -105zM442 -479l50 358l14 15h178l12 -15l-112 -358l-15 -15h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 940,
    d: "M471 -27q-130 0 -240.5 50t-179.5 139v16l113 113h18q45 -60 122 -98q80 -39 163 -39q78 0 127 33.5t49 86.5q0 44 -40 91q-14 14 -49 33q-20 10 -53 25q-6 3 -28.5 11.5t-38.5 14.5q-71 26 -119 48q-44 20 -97 55q-105 70 -105 204q0 133 101 214q100 81 271 81 q112 0 215 -47q102 -49 154 -123v-19l-113 -108h-16q-98 122 -244 120q-68 0 -109.5 -29.5t-41.5 -76.5q0 -46 42 -75q46 -31 142 -70l21 -9q86 -35 128 -57q50 -26 97 -62q100 -75 100 -223q0 -133 -107 -216q-109 -83 -282 -83zM317 -479l50 358l14 15h178l12 -15 l-112 -358l-15 -15h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 1140,
    d: "M1114 1139h-430v-1139h-227v1139h-430v192h1087v-192zM416 -479l49 358l14 15h178l13 -15l-113 -358l-14 -15h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 798,
    d: "M696 215l19 -8l65 -137l-6 -19q-95 -76 -225 -76q-150 0 -244 91q-94 90 -94 260v524h-174v174h174v309l207 25l16 -12v-322h311v-174h-311v-510q0 -172 146 -172q69 0 116 47zM397 -121l15 15h178l12 -15l-113 -358l-14 -15h-115l-12 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0237",
    unicode: "\u0237",
    horizAdvX: 522,
    d: "M152 106v918h223v-920q0 -184 -58 -278q-58 -93 -211 -166h-18l-82 162v16q83 45 115 99q31 55 31 169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02BC",
    unicode: "\u02BC",
    horizAdvX: 395,
    d: "M86 1167l51 361l17 12h182l12 -12l-119 -361l-16 -12h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 849,
    d: "M422 1491h31l329 -205v-14l-73 -103h-13l-258 138l-260 -138h-12l-74 103v14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 860,
    d: "M696 1477h13l73 -105v-12l-329 -205h-31l-330 205v12l74 105h12l260 -140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 774,
    d: "M609 1268q-91 -84 -224 -84t-223 84q-91 85 -107 217h164q12 -70 57.5 -112t109.5 -42q63 0 108 42t57 112h164q-16 -133 -106 -217z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 401,
    d: "M201 1196q-63 0 -108 46q-46 46 -46 110q0 63 45 108t109 45q63 0 109 -45t46 -108q0 -65 -44 -111q-45 -45 -111 -45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 620,
    d: "M311 1124q-98 0 -163 65q-66 65 -66 157t66 158q65 65 163 65q95 0 162 -65q66 -66 66 -158q0 -90 -67 -156t-161 -66zM250 1287q24 -25 61 -25t61 25q23 25 23 59q0 37 -23.5 61.5t-60.5 24.5t-61.5 -25t-24.5 -61q0 -35 25 -59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 591,
    d: "M442 -438q-115 0 -186 62q-72 63 -72 163q0 145 140 256l135 -35l-15 -12q-7 -7 -34 -39q-20 -22 -34 -47q-26 -47 -26 -92q0 -51 35 -84t90 -33q39 0 90 25l19 -5l43 -94l-2 -16q-86 -49 -183 -49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 897,
    d: "M600 1217q-54 0 -154 38q-99 37 -151 37q-112 0 -143 -73h-13l-12 10v145q51 84 170 84q60 0 162 -37q101 -37 141 -37q115 0 148 72h10l12 -8v-148q-51 -83 -170 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 798,
    d: "M74 1167l137 353l18 14h177l10 -14l-205 -353l-16 -14h-109zM385 1167l137 353l19 14h176l10 -14l-205 -353l-16 -14h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0326",
    unicode: "\u0326",
    horizAdvX: 0,
    d: "M-326 -479l50 358l14 15h178l12 -15l-112 -358l-15 -15h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 1947,
    d: "M1237 1554l-61 -96h-17l-438 207v16l94 152h16l406 -262v-17zM1694 1331h217l10 -18l-489 -1313h-121l-338 934l-334 -934h-123l-487 1313l10 18h229l320 -936l325 936h121l332 -946z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 1593,
    d: "M1047 1255l-68 -100h-12l-420 225v13l100 153h12l388 -278v-13zM1350 1024h211l10 -16l-375 -1008h-141l-260 692l-260 -692h-140l-368 1008l10 16h215l225 -717l260 717h119l260 -709z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 1947,
    d: "M1255 1665l-438 -207h-16l-60 96v17l404 262h16l94 -152v-16zM1694 1331h217l10 -18l-489 -1313h-121l-338 934l-334 -934h-123l-487 1313l10 18h229l320 -936l325 936h121l332 -946z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 1593,
    d: "M1040 1380l-419 -225h-15l-65 100v13l387 278h12l100 -153v-13zM1350 1024h211l10 -16l-375 -1008h-141l-260 692l-260 -692h-140l-368 1008l10 16h215l225 -717l260 717h119l260 -709z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 1947,
    d: "M754 1481q-63 0 -107 44q-45 43 -45 105t44 108q44 44 108 44q61 0 105 -44t44 -108q0 -61 -44 -105t-105 -44zM1303 1525q-47 -44 -107 -44q-61 0 -105 44t-44 105q0 62 44 108q44 44 105 44q60 0 107 -44q45 -44 45 -108q0 -62 -45 -105zM1694 1331h217l10 -18 l-489 -1313h-121l-338 934l-334 -934h-123l-487 1313l10 18h229l320 -936l325 936h121l332 -946z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 1593,
    d: "M596 1196q-59 0 -102 43t-43 103q0 59 43 102t102 43q61 0 103 -43q42 -44 42 -102q0 -60 -42 -103t-103 -43zM995 1196q-59 0 -102 43t-43 103q0 59 43 102t102 43q61 0 104 -43q42 -44 42 -102q0 -60 -42 -103q-43 -43 -104 -43zM1350 1024h211l10 -16l-375 -1008h-141 l-260 692l-260 -692h-140l-368 1008l10 16h215l225 -717l260 717h119l260 -709z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E9E",
    unicode: "\u1E9E",
    horizAdvX: 1347,
    d: "M1149 1122l-258 -313q182 -27 281 -143q98 -118 98 -273q0 -175 -126 -296q-127 -122 -343 -122q-176 0 -309 82l-11 19l78 145l19 8q86 -57 186 -57q132 0 205 70q73 69 73 172q0 102 -77 171q-79 68 -217 68h-101v162l227 270q-80 74 -202 74q-128 0 -208 -83 q-79 -82 -79 -216v-860h-227v846q0 226 147 368q145 142 377 142q141 0 273 -65q129 -65 194 -169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 1323,
    d: "M926 1554l-62 -96h-16l-438 207v16l94 152h16l406 -262v-17zM1270 1331l10 -18l-504 -813v-500h-227v498l-514 815l10 18h227l394 -643l383 643h221z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 1085,
    d: "M805 1255l-68 -100h-12l-420 225v13l101 153h12l387 -278v-13zM852 1024h201l12 -16l-475 -1086q-63 -140 -137 -198q-74 -56 -185 -56q-101 0 -168 41l-8 19l49 139l19 6q40 -27 100 -27q46 0 76.5 23t56.5 86l51 111l-417 942l12 16h221l297 -729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF8",
    unicode: "\u1EF8",
    horizAdvX: 1323,
    d: "M344 1507h-10l-15 11v157q50 84 175 84q63 0 183 -39t169 -39q109 0 139 76h10l17 -10v-158q-51 -84 -174 -84q-66 0 -181 39t-172 39q-104 0 -141 -76zM1270 1331l10 -18l-504 -813v-500h-227v498l-514 815l10 18h227l394 -643l383 643h221z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF9",
    unicode: "\u1EF9",
    horizAdvX: 1085,
    d: "M258 1219h-12l-13 10v145q51 84 170 84q59 0 161 -37t143 -37q115 0 147 72h10l13 -8v-148q-51 -85 -170 -83q-54 0 -154 38q-99 37 -152 37q-110 2 -143 -73zM852 1024h201l12 -16l-475 -1086q-63 -140 -137 -198q-74 -56 -185 -56q-101 0 -168 41l-8 19l49 139l19 6 q40 -27 100 -27q46 0 76.5 23t56.5 86l51 111l-417 942l12 16h221l297 -729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 1202,
    d: "M125 526v176h952v-176h-952z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 1495,
    d: "M125 526v176h1247v-176h-1247z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 473,
    d: "M303 1397h16l56 -47v-19q-119 -152 -119 -209q53 -10 87 -51t34 -94q0 -63 -43 -106q-44 -44 -107 -44q-68 0 -108.5 43t-40.5 115q0 85 51 177q50 90 174 235z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 468,
    d: "M180 829h-18l-53 48v18q119 153 118 209q-53 10 -87 51t-34 94q0 62 44 106q43 42 106 42q68 0 107.5 -42t39.5 -114q2 -88 -50 -178q-55 -95 -173 -234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 489,
    d: "M168 -309h-18l-54 47v18q119 152 119 209q-53 8 -87 50t-34 96q0 63 43 105t107 42q68 0 107.5 -42t39.5 -114q2 -88 -50 -178q-55 -96 -173 -233z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 860,
    d: "M303 1403h16l56 -45v-19q-119 -155 -119 -209q53 -10 87 -51t34 -96q0 -61 -43 -104t-107 -43q-68 0 -108.5 43t-40.5 112q0 87 52 179q55 96 173 233zM688 1403h19l53 -45v-19q-119 -155 -119 -209q53 -10 87 -51t34 -96q0 -61 -43 -104t-107 -43q-68 0 -107.5 42 t-39.5 113q-2 88 50 179q55 96 173 233z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 854,
    d: "M180 829h-18l-53 48v18q119 153 118 209q-53 10 -87 51t-34 94q0 62 44 106q43 42 106 42q68 0 107.5 -42t39.5 -114q2 -88 -50 -178q-55 -95 -173 -234zM565 829h-16l-55 48v18q119 153 118 209q-53 10 -86.5 50.5t-33.5 94.5q0 63 43 106q43 42 106 42q68 0 109 -43 t41 -113q0 -87 -52 -178q-53 -91 -174 -234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 874,
    d: "M168 -311h-18l-54 47v18q119 152 119 209q-53 10 -87 51t-34 95q0 63 43 105t107 42q68 0 107.5 -42t39.5 -114q2 -85 -49 -176q-53 -94 -174 -235zM553 -311h-16l-56 47v18q119 152 119 209q-53 10 -87 51t-34 95q0 63 43 105q44 42 107 42q68 0 108.5 -43t40.5 -113 q0 -86 -51 -177t-174 -234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 1052,
    d: "M637 954h315v-176h-315v-1097h-221v1097h-316v176h316v398h221v-398z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 1052,
    d: "M952 954v-176h-315v-524h315v-176h-315v-397h-221v397h-316v176h316v524h-316v176h316v398h221v-398h315z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 774,
    d: "M559 412q-72 -72 -172 -72t-172 72q-72 70 -72 172q0 100 72 171q71 70 172 70t172 -70q72 -71 72 -171q0 -102 -72 -172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 1351,
    d: "M351 21q-46 -46 -109 -46q-64 0 -109 46q-45 45 -45 109q0 63 45 108t109 45q66 0 111 -45q44 -46 44 -108q0 -64 -46 -109zM786 21q-45 -46 -108 -46q-64 0 -109 46q-45 45 -45 109q0 63 45 108t109 45q63 0 108 -45t45 -108q0 -64 -45 -109zM1219 21q-45 -46 -108 -46 q-64 0 -109 46q-46 45 -46 109q0 62 44 108q44 45 110 45t110 -45q44 -46 44 -108q0 -64 -45 -109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 2439,
    d: "M612 695q-88 -109 -229 -109t-229 109q-88 107 -88 282q0 177 88 284q89 107 229 107t229 -107q88 -107 88 -284q0 -175 -88 -282zM242 -6l-11 16l1037 1333h180l10 -16l-1034 -1333h-182zM383 735q68 0 111 67q43 65 43 175q0 111 -42 176.5t-112 65.5t-112 -66 t-42 -176q0 -109 42 -175q42 -67 112 -67zM1544 77q-88 -108 -229 -108t-229 108q-89 107 -89 284q0 175 89 284q89 107 229 107t229 -107q88 -107 88 -284q0 -178 -88 -284zM2290 77q-88 -108 -229 -108q-142 0 -230 108q-88 106 -88 284q0 177 88 284q89 107 230 107 q140 0 229 -107q88 -107 88 -284q0 -178 -88 -284zM1203 184q42 -65 112 -65q69 0 111 66q42 64 42 175q0 108 -42 176q-42 66 -111 66q-70 0 -112 -66q-42 -67 -42 -176q0 -112 42 -176zM1949 184q42 -65 112 -65q69 0 111 66q42 64 42 175q0 108 -42 176q-42 66 -111 66 q-70 0 -112 -66q-42 -67 -42 -176q0 -112 42 -176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 638,
    d: "M426 1012l109 -105v-12l-244 -283l244 -282v-13l-109 -104h-12l-340 385v31l340 383h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 638,
    d: "M213 1012h12l338 -383v-31l-338 -385h-12l-109 104v13l244 282l-244 283v12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 1128,
    d: "M-39 -6l-10 16l1036 1333h180l11 -16l-1035 -1333h-182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 1511,
    d: "M905 1151q-138 0 -247 -80q-109 -79 -156 -215h588l10 -18l-49 -115h-580q-2 -24 -2 -57q0 -34 4 -78h582l8 -19l-45 -112h-510q51 -126 158 -202q107 -75 239 -75q231 0 365 191h14l141 -117v-16q-91 -125 -226.5 -194t-297.5 -69q-223 0 -396 134q-174 134 -235 348 h-204l-11 16l47 115h144q-4 44 -4 78q0 33 2 57h-142l-10 18l45 115h129q57 222 233 362q175 138 404 138q159 0 295 -69t227 -193v-17l-141 -116h-14q-133 190 -365 190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 1542,
    d: "M260 1214h-199v117h549v-117h-200v-550h-150v550zM1341 1331l80 -667h-145l-41 366l-160 -366h-98l-158 364l-39 -364h-145l78 667h110l205 -471l203 471h110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 1241,
    d: "M131 578v178h979v-178h-979z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 1230,
    d: "M980 750q-54 -19 -134 -19q-78 0 -230 36q-153 36 -235 36q-50 0 -94.5 -20.5t-65.5 -51.5h-16l-80 123v16q22 26 50 50q23 18 76 36q56 17 130 17q88 0 253 -36t212 -36q118 0 164 72h16l80 -121v-16q-38 -40 -50 -50q-19 -18 -76 -36zM980 377q-54 -19 -134 -19 q-78 0 -230 36q-153 36 -235 36q-50 0 -94.5 -20.5t-65.5 -51.5h-16l-80 121v17q25 29 50 49q22 17 76 37q54 18 130 18q88 0 253 -36t212 -36q118 0 164 72h16l80 -123v-14q-38 -40 -50 -50q-19 -17 -76 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 1241,
    d: "M1128 924v-164h-346l-112 -189h458v-163h-557l-149 -252h-176l-8 18l139 234h-254v163h352l111 189h-463v164h561l152 254h176l8 -21l-139 -233h247z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF8FF",
    unicode: "\uF8FF",
    horizAdvX: 2758,
    d: "M1523 1210q-35 -36 -87 -36q-54 0 -87 36q-34 34 -34 88q0 52 34 86.5t87 34.5t86.5 -34.5t33.5 -86.5q0 -53 -33 -88zM365 670h-238q0 310 10 446l13 182h194q0 -5 10 -184q9 -170 11 -444zM938 965v170l238 73l8 -61h352q2 -28 4 -56.5t3 -40t1 -12.5q8 -107 8 -368 h-233q0 254 4 295h-117l4 -129q0 -2 4 -2q1 -1 19 -3q9 0 27 5l8 4v-148q-2 -8 -21 -18q-35 -15 -106 -17q-160 0 -160 131q0 7 2 103q0 13 0.5 25.5t0.5 21t0.5 15t0.5 9.5v3h-47zM756 670l-19 118q-26 -131 -151 -131q-181 0 -183 230q0 135 64.5 201.5t206.5 66.5 q119 0 178.5 -57t58.5 -172v-256h-155zM1831 670h-232q0 238 11 370q6 67 12 107h156l6 -51q6 -92 6 -101l4 21q46 139 162 139q81 0 115 -47.5t36 -159.5l4 -278h-229q0 31 2 111q2 78 2 81q0 51 -31 51q-35 0 -34 -51q0 -17 5 -82t5 -110zM2142 901q0 254 246 254 q141 0 195 -67q53 -68 53 -187q0 -116 -62.5 -180t-185.5 -64q-121 0 -183.5 64.5t-62.5 179.5zM664 817q49 0 49 62q0 55 -49 55q-43 0 -43 -55q0 -62 43 -62zM2388 817q49 0 49 62q0 55 -49 55q-47 0 -47 -55q0 -62 47 -62zM123 397v170l248 82l8 -59h338q-2 -52 -2 -107 q-2 -74 -2 -110q0 -52 32 -54q31 0 31 54v7q0 7 -0.5 18.5t-1 25t-0.5 30v29.5q-2 42 -2 107h217l6 -82q6 -78 6 -215q0 -147 -73.5 -214t-233.5 -67q-88 0 -149 21q-28 7 -41 22v170q10 -9 37 -20q44 -17 110 -19q81 0 125 37q20 17 23 37q-2 -2 -5.5 -4t-8.5 -5.5t-9 -6.5 q-33 -14 -94 -15q-190 0 -190 152v16h-93l4 -125q28 0 43 7l15 6v-152q-11 -11 -31 -18q-42 -15 -106 -17q-150 0 -150 131q0 13 0.5 34.5t1 43.5t1 42.5t1.5 34.5v13h-55zM1300 12h-260q0 290 11 420l12 158h160l6 -60q8 -46 8 -94q29 170 160 170q74 0 116.5 -60.5 t42.5 -168.5q0 -135 -67.5 -207t-192.5 -72q0 -12 2 -22q0 -2 1 -27.5t1 -36.5zM2011 281v-150q-4 -4 -35 -16q-46 -15 -112 -17q-135 0 -204 65.5t-69 182.5q0 260 252 260q107 0 168.5 -62t61.5 -171q0 -13 -7 -54l-4 -20h-245q1 -16 12 -25q25 -26 78 -24q52 0 80 14 q18 11 24 17zM2143 465q-23 23 -23 54t23 53t53 22t53 -22t23 -53t-23 -54t-53 -23t-53 23zM2153 476q18 -19 42.5 -19t43.5 19q18 18 18 42.5t-18 43.5q-19 18 -43.5 18t-42.5 -18q-19 -19 -19 -43.5t19 -42.5zM2167 481v76h33q16 0 23.5 -6t6.5 -19q0 -18 -16 -24l16 -27 h-18l-14 23h-15v-23h-16zM2183 518h17q9 0 12.5 6t0 12.5t-12.5 6.5h-17v-25zM1804 350h80v4v4q2 6 2 9q0 39 -37 39q-45 0 -45 -56zM1262 281l4 -17q28 5 39 10q40 23 38 64q0 43 -38 43q-46 0 -48 -62q0 -16 5 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J.aalt",
    horizAdvX: 1034,
    d: "M281 1139v192h593v-870q0 -242 -119 -364q-120 -122 -323 -122q-272 0 -416 205v19l136 127h16q101 -144 252 -146q99 0 164 68q63 68 63 188v703h-366z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q.aalt",
    horizAdvX: 1597,
    d: "M1440 -72l14 -6l78 -141l-6 -17q-80 -71 -199 -69q-131 0 -274 117q-17 13 -53 44q-20 18 -54 47q-22 18 -48 35q-55 37 -99 37q-305 0 -510 198t-205 493t205 493q206 197 510 197t510 -197q204 -198 204 -493q0 -213 -112 -382t-301 -249l30 -25q13 -10 36 -31 q36 -31 42 -35q12 -10 37 -25q43 -28 88 -28q64 0 107 37zM454 1014q-139 -136 -139 -348t139 -348q138 -138 345 -138t346 138q139 136 139 348t-139 348q-140 137 -346 137t-345 -137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i.aalt",
    horizAdvX: 524,
    d: "M262 1196q-63 0 -108 46t-45 110q0 63 45 108t109 45q63 0 109 -45t46 -108q0 -66 -45 -111t-111 -45zM373 0h-221v1024h221v-1024z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.salt",
    horizAdvX: 1294,
    d: "M950 903v121h197v-1024h-197v125q-146 -150 -358 -150q-224 0 -370 155t-146 382t146 382t370 155q212 0 358 -146zM623 170q137 0 228 90t91 252q0 159 -92 251q-91 91 -227 91q-143 0 -233 -98q-91 -98 -91 -244t91 -243q90 -99 233 -99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute.aalt",
    horizAdvX: 1294,
    d: "M862 1380l-420 -225h-14l-66 100v13l388 278h12l100 -153v-13zM950 903v121h197v-1024h-197v125q-146 -150 -358 -150q-224 0 -370 155t-146 382t146 382t370 155q212 0 358 -146zM623 170q137 0 228 90t91 252q0 159 -92 251q-91 91 -227 91q-143 0 -233 -98 q-91 -98 -91 -244t91 -243q90 -99 233 -99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve.aalt",
    horizAdvX: 1294,
    d: "M842 1268q-90 -84 -223 -84q-134 0 -224 84t-106 217h164q12 -70 57 -112t109 -42q63 0 108 42t57 112h164q-16 -133 -106 -217zM950 903v121h197v-1024h-197v125q-146 -150 -358 -150q-224 0 -370 155t-146 382t146 382t370 155q212 0 358 -146zM623 170q137 0 228 90 t91 252q0 159 -92 251q-91 91 -227 91q-143 0 -233 -98q-91 -98 -91 -244t91 -243q90 -99 233 -99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex.aalt",
    horizAdvX: 1294,
    d: "M621 1307l-261 -138h-12l-74 103v14l330 205h31l330 -205v-14l-74 -103h-12zM950 903v121h197v-1024h-197v125q-146 -150 -358 -150q-224 0 -370 155t-146 382t146 382t370 155q212 0 358 -146zM623 170q137 0 228 90t91 252q0 159 -92 251q-91 91 -227 91 q-143 0 -233 -98q-91 -98 -91 -244t91 -243q90 -99 233 -99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis.aalt",
    horizAdvX: 1294,
    d: "M418 1196q-59 0 -102 43q-44 44 -44 103t43 102t103 43q61 0 103 -43q42 -44 42 -102q0 -60 -42 -103t-103 -43zM817 1196q-59 0 -102 43t-43 103q0 59 43 102t102 43q61 0 104 -43q42 -44 42 -102q0 -60 -42 -103q-43 -43 -104 -43zM950 903v121h197v-1024h-197v125 q-146 -150 -358 -150q-224 0 -370 155t-146 382t146 382t370 155q212 0 358 -146zM623 170q137 0 228 90t91 252q0 159 -92 251q-91 91 -227 91q-143 0 -233 -98q-91 -98 -91 -244t91 -243q90 -99 233 -99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave.aalt",
    horizAdvX: 1294,
    d: "M868 1255l-67 -100h-13l-419 225v13l100 153h12l387 -278v-13zM950 903v121h197v-1024h-197v125q-146 -150 -358 -150q-224 0 -370 155t-146 382t146 382t370 155q212 0 358 -146zM623 170q137 0 228 90t91 252q0 159 -92 251q-91 91 -227 91q-143 0 -233 -98 q-91 -98 -91 -244t91 -243q90 -99 233 -99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron.aalt",
    horizAdvX: 1294,
    d: "M315 1391h609v-162h-609v162zM950 903v121h197v-1024h-197v125q-146 -150 -358 -150q-224 0 -370 155t-146 382t146 382t370 155q212 0 358 -146zM623 170q137 0 228 90t91 252q0 159 -92 251q-91 91 -227 91q-143 0 -233 -98q-91 -98 -91 -244t91 -243q90 -99 233 -99z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek.aalt",
    horizAdvX: 1294,
    d: "M1253 -283l19 -4l43 -94l-2 -16q-85 -49 -183 -49q-115 0 -186 62q-72 62 -72 163q0 120 101 221h-23v125q-146 -150 -358 -150q-224 0 -370 155t-146 382t146 382t370 155q212 0 358 -146v121h197v-1024l-14 -12q-15 -15 -35 -40q-21 -24 -34 -47q-22 -41 -26 -91 q0 -51 35 -84t90 -33q37 0 90 24zM623 170q137 0 228 90t91 252q0 159 -92 251q-91 91 -227 91q-143 0 -233 -98q-91 -98 -91 -244t91 -243q90 -99 233 -99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring.aalt",
    horizAdvX: 1294,
    d: "M621 1124q-97 0 -164 65q-66 65 -66 157t66 158q65 65 164 65q95 0 162 -65q65 -67 65 -158q0 -90 -66 -156q-68 -66 -161 -66zM681 1408q-36 40 -93 16.5t-53 -78.5q0 -35 24.5 -59.5t61.5 -24.5q36 0 60 24.5t24 59.5q0 36 -24 62zM950 903v121h197v-1024h-197v125 q-146 -150 -358 -150q-224 0 -370 155t-146 382t146 382t370 155q212 0 358 -146zM623 170q137 0 228 90t91 252q0 159 -92 251q-91 91 -227 91q-143 0 -233 -98q-91 -98 -91 -244t91 -243q90 -99 233 -99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde.aalt",
    horizAdvX: 1294,
    d: "M322 1219h-13l-12 10v145q51 84 170 84q58 0 160 -37q101 -37 143 -37q115 0 148 72h10l12 -8v-148q-51 -85 -170 -83q-54 0 -154 38q-99 37 -151 37q-110 2 -143 -73zM950 903v121h197v-1024h-197v125q-146 -150 -358 -150q-224 0 -370 155t-146 382t146 382t370 155 q212 0 358 -146zM623 170q137 0 228 90t91 252q0 159 -92 251q-91 91 -227 91q-143 0 -233 -98q-91 -98 -91 -244t91 -243q90 -99 233 -99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae.aalt",
    horizAdvX: 2064,
    d: "M1989 457h-818q12 -143 107 -223t227 -80q89 0 179 35q88 34 143 100h16l113 -103v-16q-76 -96 -199 -145q-121 -50 -246 -50q-213 0 -372 170v-153h-191v131q-146 -146 -356 -148q-224 0 -370 155t-146 382t146 382t370 155q209 0 356 -144v127h191v-127 q142 142 356 144q222 0 361 -148t139 -373q0 -44 -6 -71zM1680 800q-82 74 -205 74q-124 0 -206 -74q-82 -76 -98 -202h605q-16 127 -96 202zM623 170q137 0 228 90t91 252q0 159 -92 251q-91 91 -227 91q-143 0 -233 -98q-91 -98 -91 -244t91 -243q90 -99 233 -99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute.aalt",
    horizAdvX: 2064,
    d: "M1290 1380l-420 -225h-14l-65 100v13l387 278h12l100 -153v-13zM1989 457h-818q12 -143 107 -223t227 -80q89 0 179 35q88 34 143 100h16l113 -103v-16q-76 -96 -199 -145q-121 -50 -246 -50q-213 0 -372 170v-153h-191v131q-146 -146 -356 -148q-224 0 -370 155 t-146 382t146 382t370 155q209 0 356 -144v127h191v-127q142 142 356 144q222 0 361 -148t139 -373q0 -44 -6 -71zM1680 800q-82 74 -205 74q-124 0 -206 -74q-82 -76 -98 -202h605q-16 127 -96 202zM623 170q137 0 228 90t91 252q0 159 -92 251q-91 91 -227 91 q-143 0 -233 -98q-91 -98 -91 -244t91 -243q90 -99 233 -99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_t.dlig",
    horizAdvX: 1449,
    d: "M1348 215l18 -8l66 -137l-7 -19q-95 -76 -227 -76q-150 0 -243 90q-93 89 -93 261v524h-409v-850h-222v850h-174v174h174v29q0 179 101 280q100 99 256 99q89 0 164 -37l8 -17l-51 -139l-19 -8q-40 20 -80 20q-158 0 -157 -198v-29h409v309l205 25l16 -12v-322h314v-174 h-314v-510q0 -172 148 -172q70 0 117 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine.aalt",
    horizAdvX: 927,
    d: "M811 831l10 -4l25 -102l-6 -10q-38 -27 -90 -27q-96 0 -129 88q-91 -88 -220 -88q-143 0 -234 96q-91 94 -91 236q0 141 91 238q91 96 234 96q123 0 215 -86v71h138v-467q0 -51 34 -51q13 0 23 10zM418 825q83 0 134.5 53t51.5 142q0 91 -52 144q-53 53 -134 53 q-80 0 -132 -57q-53 -59 -53 -140q0 -82 53 -138q52 -57 132 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand.aalt",
    horizAdvX: 1294,
    d: "M852 768h412v-168h-170q55 -82 55 -186q0 -201 -150 -327q-151 -126 -388 -126q-239 0 -387 127q-150 127 -150 328q0 123 67 219.5t187 155.5q-136 85 -138 249q0 149 110 244q109 94 288 94q256 0 401 -204v-17l-121 -94h-18q-90 141 -250 141q-92 0 -147.5 -45.5 t-55.5 -118.5q0 -75 57.5 -119t153.5 -44h76v-179h-74q-144 0 -230 -76q-87 -76 -87 -200t88 -200q89 -77 229 -77q138 0 229 77q89 77 89 200q0 96 -76 178v168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "glyph370",
    horizAdvX: 0,
    d: "M-346 1059l53 387l17 12h182l12 -12l-123 -387l-16 -12h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute.aalt",
    horizAdvX: 661,
    d: "M96 1260l404 262h16l94 -152v-16l-438 -207h-16l-60 96v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve.aalt",
    horizAdvX: 796,
    d: "M614 1256q-89 -85 -217 -85q-127 0 -216 84q-90 85 -103 218h164q10 -72 51 -113t105 -41q63 0 104 41t51 113h164q-13 -132 -103 -217z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron.aalt",
    horizAdvX: 829,
    d: "M698 1495h15l65 -102v-17l-354 -202h-21l-352 202v17l64 102h16l285 -139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex.aalt",
    horizAdvX: 829,
    d: "M397 1503h21l356 -200v-17l-67 -108h-17l-282 137l-283 -137h-16l-68 108v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis.aalt",
    horizAdvX: 913,
    d: "M236 1178q-63 0 -107 44q-45 44 -45 105q0 62 44 108q44 44 108 44q61 0 105 -44t44 -108q0 -61 -44 -105t-105 -44zM784 1222q-46 -44 -106 -44q-62 0 -106 44t-44 105q0 62 44 108q44 44 106 44q60 0 106 -44q45 -43 45 -108q0 -61 -45 -105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent.aalt",
    horizAdvX: 468,
    d: "M233 1178q-59 0 -105 46t-46 105q0 63 45 109q45 45 106 45q63 0 109 -45q45 -45 45 -109q0 -61 -46 -106q-47 -45 -108 -45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave.aalt",
    horizAdvX: 661,
    d: "M170 1522h16l406 -262v-17l-62 -96h-16l-438 207v16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut.aalt",
    horizAdvX: 890,
    d: "M76 1143l184 323h199l10 -16l-240 -322h-145zM420 1143l186 323h197l10 -16l-240 -322h-145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron.aalt",
    horizAdvX: 786,
    d: "M82 1200v162h625v-162h-625z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring.aalt",
    horizAdvX: 550,
    d: "M436 1200q-68 -65 -159 -65q-92 0 -159 65q-67 64 -67 156q0 93 67 157q65 64 159 64q92 0 159 -64q66 -65 66 -157t-66 -156zM276 1264q36 0 63.5 28t27.5 64t-27.5 64t-63.5 28q-37 0 -63.5 -27.5t-26.5 -64.5q0 -39 26.5 -65.5t63.5 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde.aalt",
    horizAdvX: 968,
    d: "M686 1202q-66 0 -181 39t-171 39q-104 0 -141 -76h-11l-14 10v158q50 84 174 84q63 0 183 -39t169 -39q109 0 140 76h10l16 -10v-158q-51 -84 -174 -84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "glyph382",
    horizAdvX: 1517,
    d: "M74 1458h-17l-59 96v15l403 264h17l94 -152v-16zM1057 1458h-15l-61 96v15l405 264h15l94 -152v-16zM401 0h-227v1331h227v-1331zM915 -25q-270 0 -417 205v19l135 127h18q101 -144 252 -146q99 0 164 68q63 68 63 188v895h228v-870q0 -243 -121 -364 q-122 -122 -322 -122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "glyph383",
    horizAdvX: 1517,
    d: "M88 1458h-16l-60 96v15l404 264h16l94 -152v-16zM881 1458h-17l-61 96v15l405 264h17l92 -152v-16zM401 0h-227v1331h227v-1331zM918 -25q-270 0 -418 205v19l137 127h16q97 -144 252 -146q98 0 163 68t65 188v703h-367v192h592v-870q0 -242 -119 -364 q-120 -122 -321 -122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "glyph384",
    horizAdvX: 1054,
    d: "M610 1155h-12l-63 100v13l391 280h14l98 -155v-13zM86 1155h-14l-66 100v13l385 278h15l98 -153v-13zM373 0h-221v1024h221v-1024zM639 -340h-18l-82 162v16q83 45 115 99q30 55 30 169v918h223v-920q0 -184 -58 -278t-210 -166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "glyph385",
    horizAdvX: 1337,
    d: "M319 -106h-210l-11 18l1032 1550h209l11 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "glyph386",
    horizAdvX: 1159,
    d: "M260 55h-207l-10 19l856 1229h205l10 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "glyph387",
    horizAdvX: 804,
    d: "M778 928v-180l-712 -351l-19 9v180l715 350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "glyph388",
    horizAdvX: 755,
    d: "M674 713l-576 -299l-16 10v156l573 297l19 -9v-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "glyph389",
    horizAdvX: 1548,
    d: "M98 940v154h1323v-154h-1323z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "glyph390",
    horizAdvX: 747,
    d: "M686 592h-625v141h625v-141z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "J.aalt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u201E",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u201A",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u02BC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\xAE",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "v",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "_",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "V",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "J",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "*",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "glyph384",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0166",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u012B",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0129",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0127",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xEF",
    k: -154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xEE",
    k: -117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xED",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xEC",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "J.aalt",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0166",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "x",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "X",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "M",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "J",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: " ",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "glyph384",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0166",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u012B",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0129",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0127",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xEF",
    k: -154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xEE",
    k: -117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xED",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xEC",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "glyph384",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "glyph383",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "glyph382",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "J.aalt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u1E9E",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0142",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u013A",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0139",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012B",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012A",
    k: -68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0129",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0128",
    k: -90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF0",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xEF",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xEE",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xED",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xEC",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xCF",
    k: -109
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xCE",
    k: -117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xCD",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "{",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "v",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "M",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "J",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "9",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "8",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "6",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "5",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "4",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "(",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ")",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ")",
    u2: ")",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "glyph384",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "J.aalt",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0166",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0142",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u012B",
    k: -76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0129",
    k: -90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0127",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0126",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF0",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xEF",
    k: -102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xEE",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xED",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xBF",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "v",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "M",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "J",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "7",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "4",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "2",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "1",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: " ",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0166",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0166",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0166",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "J.aalt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E9E",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "M",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "J",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "8",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "6",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "4",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 473
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    g2: "J.aalt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "}",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "]",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "X",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "J",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "/",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ")",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\u2212",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\xB7",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: ")",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    g2: "ordfeminine.aalt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xBA",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xB0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xAA",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "}",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "]",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\\\\\\\\",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "V",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "9",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "1",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "*",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: ")",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    g2: "ordfeminine.aalt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\xBA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\xB0",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "}",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "]",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\\\\\\\\",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "X",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "V",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "7",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "1",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "*",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: ")",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    g2: "ordfeminine.aalt",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    g2: "J.aalt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2212",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xF7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xBA",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xB7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xB0",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "M",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "J",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "8",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "6",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "/",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "+",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "*",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "}",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "]",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\\\\\\\\",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: ")",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    g2: "J.aalt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "}",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "]",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "M",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "J",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "/",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ")",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u01FF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0153",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0151",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u014D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u011B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0119",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0117",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0113",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u010D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u010B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0107",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\xF8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\xF6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\xF5",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\xF4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\xF3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\xF2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\xF0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\xEB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\xEA",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\xE9",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\xE8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\xE7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "o",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "e",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "c",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "X",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u02BC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "}",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "]",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\\\\\\\\",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "J",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: ")",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u0127",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0166",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u012B",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0129",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0127",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\xEF",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\xEE",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "glyph384",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "ordfeminine.aalt",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "J.aalt",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2122",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E9E",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u02BC",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0142",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0131",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u012B",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0129",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0127",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEF",
    k: -104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEE",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xED",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xDF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xBA",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xAE",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "M",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "J",
    k: 211
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "?",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "5",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "4",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "*",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: " ",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\xEF",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\xEF",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u012B",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u0129",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xEF",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    g2: "glyph384",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0167",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u012B",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0129",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0127",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xF8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xEF",
    k: -102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xEE",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xED",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    g2: "ordfeminine.aalt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u2122",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u02BC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u0142",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xF0",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xBA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xAA",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "v",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\\\\\\\\",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "N",
    u2: "\xEF",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0166",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "ordfeminine.aalt",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "J.aalt",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0142",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xBA",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xAE",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "}",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "]",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "M",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "J",
    k: 201
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "?",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "4",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ")",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: " ",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: ")",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "glyph384",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0167",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0161",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0159",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0131",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u012B",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0129",
    k: -96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0127",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEF",
    k: -121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEE",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xED",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEB",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xDF",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u012B",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0129",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0127",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xEF",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "glyph384",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "ampersand.aalt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "adieresis.aalt",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "J.aalt",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2122",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E9E",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u02BC",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0167",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0142",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0131",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012B",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0129",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0127",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEF",
    k: -98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEE",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xED",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEB",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xDF",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xA9",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "}",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "]",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "M",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "J",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "@",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "8",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "6",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "4",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "1",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "0",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "!",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: " ",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    g2: "glyph384",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0167",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0131",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u012B",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0129",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0127",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEF",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEE",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xED",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xDF",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "glyph384",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2122",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u02BC",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0167",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0142",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0131",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u012B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0129",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0127",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEF",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEE",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xED",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xDF",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xA9",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "6",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "4",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "0",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    g2: "glyph384",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    g2: "adieresis.aalt",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0167",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0131",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u012B",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0129",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0127",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF6",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEF",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEE",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xED",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEB",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE4",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xDF",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0167",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0129",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0127",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xEF",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    g2: "glyph384",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    g2: "glyph382",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u01FF",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0142",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u013A",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u012B",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u012A",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0129",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0128",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0127",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xF8",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xF0",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xEF",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xEE",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xED",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xEC",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xCF",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xCE",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "v",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "V",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "J",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "8",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "6",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "4",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "v",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\\\\\\\\",
    k: 473
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "V",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "9",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "_",
    u2: " ",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\xEF",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    g2: "glyph384",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    g2: "ordfeminine.aalt",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u2122",
    k: -158
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u02BC",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0142",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012B",
    k: -102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0129",
    k: -115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xF0",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEF",
    k: -162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEE",
    k: -90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xED",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEC",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xBA",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xAE",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xAA",
    k: -78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "}",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "]",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\\\\\\\\",
    k: -76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "X",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "V",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "M",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "J",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "?",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "/",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "*",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ")",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "!",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: " ",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\u0129",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\xEF",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0129",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\xEF",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\xEE",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "\xEF",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "ordfeminine.aalt",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u02BC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0142",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF0",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xBA",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xAE",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xAA",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "}",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "]",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "X",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "M",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "J",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "?",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "*",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ")",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: " ",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    g2: "ordfeminine.aalt",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0142",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xBA",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xAE",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xAA",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "?",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    g2: "glyph384",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    g2: "glyph383",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    g2: "glyph382",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u01FF",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0142",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u013A",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u012B",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u012A",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0129",
    k: -68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0128",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0127",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xF8",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xF0",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xEF",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xEE",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xED",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xEC",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xCF",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xCE",
    k: -86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xCD",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "v",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "X",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "V",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "J",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "6",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "4",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "0",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "}",
    u2: "\u02BC",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "}",
    u2: ")",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA1",
    u2: "\u0166",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA1",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA9",
    u2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA9",
    u2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA9",
    u2: "J",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: " ",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u0166",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    g2: "glyph384",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    g2: "J.aalt",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\u0166",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\u012B",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\u0129",
    k: -90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\u0127",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\u0126",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\xF0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\xEF",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\xEE",
    k: -78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\xED",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "x",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "v",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "M",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "J",
    k: 197
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: " ",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "7",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "2",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "1",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: " ",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0166",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u01FF",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0142",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xF8",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xF0",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "v",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "V",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u02BC",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC6",
    u2: "\xEF",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC6",
    u2: "\xEE",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u0127",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC8",
    u2: "\xEF",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC8",
    u2: "\xEE",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC9",
    u2: "\xEF",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC9",
    u2: "\xEE",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCA",
    u2: "\xEF",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCA",
    u2: "\xEE",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCB",
    u2: "\xEF",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCB",
    u2: "\xEE",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCC",
    u2: "\u02BC",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCC",
    u2: "\xEF",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCC",
    u2: "}",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCC",
    u2: ")",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCD",
    u2: "\xEF",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCE",
    u2: "\u02BC",
    k: -121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCE",
    u2: "\xEF",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCE",
    u2: "\xEC",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCE",
    u2: "}",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCE",
    u2: "]",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCE",
    u2: ")",
    k: -109
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCF",
    u2: "\u02BC",
    k: -139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCF",
    u2: "\xEC",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCF",
    u2: "}",
    k: -78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCF",
    u2: "i",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCF",
    u2: "]",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCF",
    u2: ")",
    k: -109
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u02BC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "}",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "]",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: ")",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xEF",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xEF",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xEF",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xEF",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF6",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xED",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "J.aalt",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2122",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u02BC",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "}",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "]",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\\\\\\\\",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "X",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "M",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "J",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ")",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "ordfeminine.aalt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\u2122",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\u02BC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xBA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xAE",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xAA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "x",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\\\\\\\\",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: ")",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\u02BC",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\u02BC",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u2122",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u02BC",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\xEF",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u02BC",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u02BC",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\xEF",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    g2: "ordfeminine.aalt",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "\u2122",
    k: -125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "\u201D",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "\u201C",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "\u2019",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "\u2018",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "\u02BC",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "\xEF",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "\xEE",
    k: -68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "\xED",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "\xEC",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "\xBA",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "\xAE",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "\xAA",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "}",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "]",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "*",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "'",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "\"",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xED",
    u2: "\u2122",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xED",
    u2: "\u201D",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xED",
    u2: "\u2019",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xED",
    u2: "\u02BC",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xED",
    u2: "\xEF",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xED",
    u2: "\xEE",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xED",
    u2: "\xED",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xED",
    u2: "\xEC",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xED",
    u2: "}",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    g2: "ordfeminine.aalt",
    k: -88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u2122",
    k: -170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u201D",
    k: -109
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u201C",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u2019",
    k: -109
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u2018",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u02BC",
    k: -127
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\xEF",
    k: -152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\xEE",
    k: -135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\xED",
    k: -76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\xEC",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\xBA",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\xAE",
    k: -78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\xAA",
    k: -96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "}",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "]",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "?",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "*",
    k: -86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: ")",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "'",
    k: -117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\"",
    k: -117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "!",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    g2: "ordfeminine.aalt",
    k: -98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u2122",
    k: -203
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u201D",
    k: -137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u201C",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u2019",
    k: -137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u2018",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u02BC",
    k: -150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u0137",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u0127",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\xFE",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\xEE",
    k: -152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\xEC",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\xEB",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\xDF",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\xBA",
    k: -106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\xAE",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\xAA",
    k: -131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "}",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "l",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "k",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "j",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "i",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "h",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "b",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "]",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "?",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "*",
    k: -102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: ")",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "'",
    k: -154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\"",
    k: -154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "!",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\u02BC",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\xBA",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "v",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "]",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: ")",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u02BC",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "7",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "3",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    g2: "ordfeminine.aalt",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u2122",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u201D",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u201C",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u2019",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u2018",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u02BC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\xBA",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\xAE",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "?",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "*",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "'",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\"",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: "\u02BC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ")",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0101",
    u2: "\u02BC",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0103",
    u2: "\u02BC",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u201E",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u201A",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "}",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "y",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "p",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "j",
    k: -88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "_",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "]",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: ";",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: ",",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: ")",
    k: -88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "_",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: ")",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\u0127",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "\u0127",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "\u0127",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "\u02BC",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "aacute.aalt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u201C",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u017E",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    g2: "ordfeminine.aalt",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "\u2122",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "\u201D",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "\u201C",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "\u2019",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "\u2018",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "\u02BC",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "\u0129",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "\xED",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "\xBA",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "\xAE",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "\xAA",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "}",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "]",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "?",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "*",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "'",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "\"",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "!",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0112",
    u2: "\xEF",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0116",
    u2: "\xEF",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\xEF",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "}",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "j",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "_",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: ";",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: ",",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: ")",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011A",
    u2: "\xEF",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u02BC",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "ordfeminine.aalt",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u2122",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u201D",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u201C",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u2019",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u2018",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0127",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xBA",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xAE",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "?",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "*",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0128",
    u2: "\u02BC",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0128",
    u2: "}",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0128",
    u2: ")",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    g2: "ordfeminine.aalt",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2122",
    k: -160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u201D",
    k: -104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u201C",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2019",
    k: -104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2018",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u02BC",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u0129",
    k: -137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xBA",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xAE",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xAA",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "}",
    k: -76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "j",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "i",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "]",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "*",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: ")",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "'",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\"",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "!",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012A",
    u2: "\u02BC",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012A",
    u2: "}",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012A",
    u2: "]",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012A",
    u2: ")",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    g2: "ordfeminine.aalt",
    k: -86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u2122",
    k: -143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u201D",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u201C",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u2019",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u2018",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u02BC",
    k: -104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\xBA",
    k: -90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\xAE",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\xAA",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "}",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "j",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "]",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "?",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "*",
    k: -78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: ")",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "'",
    k: -96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\"",
    k: -96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "!",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: ")",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0131",
    u2: "\u2122",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0132",
    u2: "\u012B",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0132",
    u2: "\u0129",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0132",
    u2: "\xEF",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u012B",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    g2: "ordfeminine.aalt",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u2122",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u201D",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u201C",
    k: 186
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u2019",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u2018",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u02BC",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\xBA",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\xAE",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\xAA",
    k: 174
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "Y",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "W",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "V",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "T",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "*",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "'",
    k: 145
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\"",
    k: 145
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "aacute.aalt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u201C",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u017E",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0161",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u010D",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "\u02BC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "\u0142",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "?",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: ")",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0148",
    u2: "\u02BC",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u02BC",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: ")",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\xEF",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "\u02BC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "}",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "\u2122",
    k: -113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "\u201D",
    k: -76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "\u2019",
    k: -76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "\u02BC",
    k: -90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "\xAA",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "}",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "]",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: ")",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "'",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "\"",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "\u2122",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "\u02BC",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u0167",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xEE",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xED",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "}",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "_",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: ")",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u0167",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u0161",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xEE",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xED",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    g2: "ordfeminine.aalt",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u2122",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u201D",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u201C",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u2019",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u2018",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u02BC",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xED",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xBA",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xAE",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xAA",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "}",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "j",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "i",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "]",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "*",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: ")",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "'",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\"",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "!",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "ordfeminine.aalt",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "aeacute.aalt",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "ae.aalt",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "atilde.aalt",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "aring.aalt",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "aogonek.aalt",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "amacron.aalt",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "agrave.aalt",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "adieresis.aalt",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "acircumflex.aalt",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "abreve.aalt",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "aacute.aalt",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.salt",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Q.aalt",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2122",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u203A",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2039",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2026",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u201E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u201D",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u201A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2019",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2018",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2014",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2013",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u02BC",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FF",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FE",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01EB",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01EA",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0167",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0153",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0152",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0151",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0150",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014D",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014C",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0123",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0122",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0121",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0120",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011F",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011E",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011B",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0119",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0117",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0113",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0111",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010F",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010D",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010C",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010B",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0107",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0106",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0105",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0103",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0101",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF8",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF6",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF5",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF4",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF3",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xEE",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xED",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xEB",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xEA",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE9",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE8",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE7",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD3",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC7",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xBB",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xBA",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAE",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAB",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xA9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "s",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "q",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "o",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "g",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "e",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "d",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "c",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "a",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "Q",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "O",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "G",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "C",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "?",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ".",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "-",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ",",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "*",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "'",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "&",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\"",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\xEF",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\xEF",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\xEF",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\xEF",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0171",
    u2: "\u02BC",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\xEF",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: ")",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xF6",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xED",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF6",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xED",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017E",
    u2: "\u02BC",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FC",
    u2: "\xEF",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u02BC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "}",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "]",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: ")",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    g2: "ordfeminine.aalt",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "\u2122",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "\u201D",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "\u201C",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "\u2019",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "\u2018",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "\u02BC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "\xBA",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "\xAE",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "?",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "*",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "'",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "\"",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\u0167",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xEE",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xED",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "glyph384",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "glyph383",
    k: -137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "glyph382",
    k: -152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "atilde.aalt",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "amacron.aalt",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "adieresis.aalt",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "acircumflex.aalt",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "abreve.aalt",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "J.aalt",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u1E9E",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u017E",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u0161",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u015B",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u0159",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u014D",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u0142",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u013A",
    k: -135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u0139",
    k: -117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u0130",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u012B",
    k: -106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u012A",
    k: -150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u0129",
    k: -129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u0128",
    k: -174
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u0127",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u011F",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u011B",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u0113",
    k: 145
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u010D",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u0107",
    k: 158
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u0103",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u0101",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\u0100",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xFF",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xFC",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xF6",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xF4",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xF0",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xEF",
    k: -160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xEE",
    k: -104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xED",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xEC",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xEB",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xEA",
    k: 145
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xE4",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xE3",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xE2",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xCF",
    k: -190
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xCE",
    k: -195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xCD",
    k: -137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xCC",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xCB",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xC4",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xC3",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xC2",
    k: 174
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xBF",
    k: 182
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "\xA1",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "{",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "x",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "v",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "V",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "M",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "J",
    k: 188
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "(",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: " ",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    g2: "ordfeminine.aalt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u2122",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u02BC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xBA",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xAE",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xAA",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "}",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "]",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\\\\\\\\",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "X",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "*",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: ")",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xF6",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xED",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xF6",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xED",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0166",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0166",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "glyph384",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u012B",
    k: -98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0129",
    k: -115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0127",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xEF",
    k: -158
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xEE",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xED",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xEC",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "glyph384",
    k: -96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0166",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0161",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0159",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u012B",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0129",
    k: -150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0127",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0126",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xEF",
    k: -182
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xEE",
    k: -154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xED",
    k: -96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xEC",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u01FC",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0166",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xC6",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: " ",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "glyph384",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u1EF9",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u1EF3",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0177",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0166",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u012B",
    k: -98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0129",
    k: -115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0127",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xFF",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xFD",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xEF",
    k: -158
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xEE",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xED",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xEC",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "y",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "x",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "v",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    g2: "glyph384",
    k: -96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0166",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0161",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0159",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u012B",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0129",
    k: -150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0127",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0126",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xEF",
    k: -182
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xEE",
    k: -154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xED",
    k: -96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xEC",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u01FC",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0166",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xC6",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: " ",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2020",
    g2: "J.aalt",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2020",
    u2: "J",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\u0166",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0166",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0166",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: " ",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "7",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "3",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "2",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "1",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uniFB01",
    u2: "\xEF",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uniFB02",
    u2: "\xEF",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.aalt",
    u2: "\u012B",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.aalt",
    u2: "\u0129",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.aalt",
    u2: "\xEF",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.aalt",
    u2: "\u0104",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.aalt",
    u2: "\u0102",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.aalt",
    u2: "\u0100",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.aalt",
    u2: "\xC6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.aalt",
    u2: "\xC5",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.aalt",
    u2: "\xC4",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.aalt",
    u2: "\xC3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.aalt",
    u2: "\xC2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.aalt",
    u2: "\xC1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.aalt",
    u2: "\xC0",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.aalt",
    u2: "}",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.aalt",
    u2: "x",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.aalt",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.aalt",
    u2: "_",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.aalt",
    u2: "]",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.aalt",
    u2: "X",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.aalt",
    u2: "A",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.aalt",
    u2: "/",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.aalt",
    u2: ")",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "aogonek.aalt",
    u2: ")",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordfeminine.aalt",
    u2: " ",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand.aalt",
    u2: "\u0166",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand.aalt",
    u2: "X",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand.aalt",
    u2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand.aalt",
    u2: " ",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "glyph382",
    u2: "\u012B",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "glyph382",
    u2: "\u0129",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "glyph382",
    u2: "\xEF",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "glyph383",
    u2: "\u012B",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "glyph383",
    u2: "\u0129",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "glyph383",
    u2: "\xEF",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "glyph384",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "glyph384",
    u2: "\u201D",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "glyph384",
    u2: "\u2019",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "glyph384",
    u2: "\u02BC",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "glyph384",
    u2: "}",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "glyph384",
    u2: "]",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "glyph384",
    u2: ")",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "glyph384",
    u2: "'",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "glyph384",
    u2: "\"",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "glyph384",
    u2: "!",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "guillemotleft,guilsinglleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "hyphen,endash,emdash",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni02BC",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni02BC",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni02BC",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "colon,semicolon",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quoteleft,quotedblleft",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quoteright,quotedblright",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quotedbl,quotesingle",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni02BC",
    k: 182
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "colon,semicolon",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "quoteleft,quotedblleft",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "quoteright,quotedblright",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "quotedbl,quotesingle",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "one",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "seven",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "three",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "two",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "guillemotleft,guilsinglleft",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "hyphen,endash,emdash",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "uni02BC",
    k: 197
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "quoteleft,quotedblleft",
    k: 207
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "quoteright,quotedblright",
    k: 209
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "quotedbl,quotesingle",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "one",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "seven",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "asterisk",
    k: 211
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "braceleft",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "copyright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "nine",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "parenleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "registered",
    k: 211
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "space",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "zero",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "guillemotleft,guilsinglleft",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "hyphen,endash,emdash",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 207
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "one",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "seven",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "space",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "four",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "questiondown",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "six",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotleft,guilsinglleft",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "hyphen,endash,emdash",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 219
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "quoteright,quotedblright",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "one",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "seven",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "two",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "space",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "four",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "questiondown",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "six",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotleft,guilsinglleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "hyphen,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "one",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "seven",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "space",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "questiondown",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "six",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 213
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "question",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand.aalt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "copyright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "registered",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 211
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "trademark",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "quoteleft,quotedblleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "quoteright,quotedblright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "quotedbl,quotesingle",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "quoteright,quotedblright",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "quotedbl,quotesingle",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "hyphen,endash,emdash",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "quoteleft,quotedblleft",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "quoteright,quotedblright",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "quotedbl,quotesingle",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "hyphen,endash,emdash",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quoteleft,quotedblleft",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quoteright,quotedblright",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quotedbl,quotesingle",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "colon,semicolon",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "guillemotleft,guilsinglleft",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "guillemotright,guilsinglright",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "hyphen,endash,emdash",
    k: 190
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 197
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 145
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "guillemotleft,guilsinglleft",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "hyphen,endash,emdash",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "quoteleft,quotedblleft",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "quoteright,quotedblright",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "quotedbl,quotesingle",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "V",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "asterisk",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "backslash",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "dagger",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "eth",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "lslash",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "nine",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "one",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "ordfeminine",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "ordfeminine.aalt",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "ordmasculine",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "question",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "registered",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "seven",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "space",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "trademark",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "uni02BC",
    k: 182
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "v",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "zero",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "braceright",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "bracketright",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "copyright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "eight",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "six",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "guillemotleft,guilsinglleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "hyphen,endash,emdash",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "quoteright,quotedblright",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "asterisk",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "lslash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "ordfeminine.aalt",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "ordmasculine",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "question",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "registered",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "AE,AEacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "parenright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "X",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "backslash",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "one",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "seven",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "uni02BC",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "braceright",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "bracketright",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "AE,AEacute",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "parenright",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "X",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "J",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "J.aalt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "slash",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "three",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "two",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "x",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "b,h,k,germandbls,thorn,hbar,uni0137",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,ij,i.aalt,glyph384",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "j,uni0237",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "l,lacute,uni013C,lcaron,ldot",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat",
    g2: "M",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE,AEacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE,AEacute",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE,AEacute",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE,AEacute",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE,AEacute",
    g2: "hyphen,endash,emdash",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE,AEacute",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE,AEacute",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE,AEacute",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE,AEacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE,AEacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE,AEacute",
    g2: "eth",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE,AEacute",
    g2: "lslash",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE,AEacute",
    g2: "v",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE,AEacute",
    g2: "zero",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE,AEacute",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE,AEacute",
    g2: "six",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE,AEacute",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,ij,i.aalt,glyph384",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE,AEacute",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE,AEacute",
    g2: "four",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "quoteleft,quotedblleft",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "quoteright,quotedblright",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "backslash",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "one",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "seven",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "uni02BC",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "braceright",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "bracketright",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "AE,AEacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "parenright",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "X",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "J",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "J.aalt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "slash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "three",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "two",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "b,h,k,germandbls,thorn,hbar,uni0137",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,ij,i.aalt,glyph384",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "j,uni0237",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "l,lacute,uni013C,lcaron,ldot",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "M",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Itilde,Imacron,Iogonek,Idot,Nacute,uni0145,Ncaron,Eng",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Itilde,Imacron,Iogonek,Idot,Nacute,uni0145,Ncaron,Eng",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Itilde,Imacron,Iogonek,Idot,Nacute,uni0145,Ncaron,Eng",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Itilde,Imacron,Iogonek,Idot,Nacute,uni0145,Ncaron,Eng",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Itilde,Imacron,Iogonek,Idot,Nacute,uni0145,Ncaron,Eng",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Itilde,Imacron,Iogonek,Idot,Nacute,uni0145,Ncaron,Eng",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Itilde,Imacron,Iogonek,Idot,Nacute,uni0145,Ncaron,Eng",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Itilde,Imacron,Iogonek,Idot,Nacute,uni0145,Ncaron,Eng",
    g2: "eth",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Itilde,Imacron,Iogonek,Idot,Nacute,uni0145,Ncaron,Eng",
    g2: "lslash",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Itilde,Imacron,Iogonek,Idot,Nacute,uni0145,Ncaron,Eng",
    g2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Itilde,Imacron,Iogonek,Idot,Nacute,uni0145,Ncaron,Eng",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Itilde,Imacron,Iogonek,Idot,Nacute,uni0145,Ncaron,Eng",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Itilde,Imacron,Iogonek,Idot,Nacute,uni0145,Ncaron,Eng",
    g2: "b,h,k,germandbls,thorn,hbar,uni0137",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Itilde,Imacron,Iogonek,Idot,Nacute,uni0145,Ncaron,Eng",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,ij,i.aalt,glyph384",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Itilde,Imacron,Iogonek,Idot,Nacute,uni0145,Ncaron,Eng",
    g2: "j,uni0237",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Itilde,Imacron,Iogonek,Idot,Nacute,uni0145,Ncaron,Eng",
    g2: "l,lacute,uni013C,lcaron,ldot",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Itilde,Imacron,Iogonek,Idot,Nacute,uni0145,Ncaron,Eng",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Itilde,Imacron,Iogonek,Idot,Nacute,uni0145,Ncaron,Eng",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "eth",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "lslash",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "parenright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "J.aalt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "slash",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "b,h,k,germandbls,thorn,hbar,uni0137",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,ij,i.aalt,glyph384",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "j,uni0237",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "l,lacute,uni013C,lcaron,ldot",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,J.aalt,glyph382,glyph383",
    g2: "M",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "guillemotleft,guilsinglleft",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "hyphen,endash,emdash",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "quoteright,quotedblright",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "quotedbl,quotesingle",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "eth",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "lslash",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "nine",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "space",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "trademark",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "uni02BC",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "v",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "zero",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "braceright",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "bracketright",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "copyright",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "six",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "four",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "guillemotright,guilsinglright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 188
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "guillemotleft,guilsinglleft",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "hyphen,endash,emdash",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "quoteleft,quotedblleft",
    k: 201
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "quoteright,quotedblright",
    k: 201
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "quotedbl,quotesingle",
    k: 190
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "V",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "asterisk",
    k: 201
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "backslash",
    k: 186
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "dagger",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "eth",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "lslash",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "nine",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "one",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "ordfeminine",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "ordfeminine.aalt",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "ordmasculine",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "question",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "registered",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "seven",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "space",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "trademark",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "uni02BC",
    k: 188
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "v",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "zero",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "copyright",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "AE,AEacute",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "four",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "guillemotright,guilsinglright",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "middot",
    k: 297
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "V",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "backslash",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "one",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "seven",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "uni02BC",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "braceright",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "bracketright",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "AE,AEacute",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "parenright",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "X",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "J",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "J.aalt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "slash",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "three",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "two",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "x",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "b,h,k,germandbls,thorn,hbar,uni0137",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,ij,i.aalt,glyph384",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "j,uni0237",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "l,lacute,uni013C,lcaron,ldot",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Ohungarumlaut,uni01EA,Oslashacute,Q.aalt",
    g2: "M",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "hyphen,endash,emdash",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "backslash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "eth",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "lslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "uni02BC",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "six",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "parenright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "X",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "J.aalt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "b,h,k,germandbls,thorn,hbar,uni0137",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,ij,i.aalt,glyph384",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "l,lacute,uni013C,lcaron,ldot",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "four",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "hyphen,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "lslash",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "v",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "AE,AEacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "parenright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "J",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "x",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "b,h,k,germandbls,thorn,hbar,uni0137",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,ij,i.aalt,glyph384",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "j,uni0237",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "l,lacute,uni013C,lcaron,ldot",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "guillemotleft,guilsinglleft",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "hyphen,endash,emdash",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "quoteleft,quotedblleft",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "quoteright,quotedblright",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "quotedbl,quotesingle",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "asterisk",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "dagger",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "eth",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "lslash",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "one",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "ordfeminine",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "ordfeminine.aalt",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "ordmasculine",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "question",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "registered",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "space",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "trademark",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "uni02BC",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "v",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "zero",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "copyright",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "eight",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "six",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 145
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "AE,AEacute",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "J",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "J.aalt",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "slash",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "x",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,ij,i.aalt,glyph384",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "j,uni0237",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "M",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "four",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "guillemotright,guilsinglright",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "colon,semicolon",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "uni1E9E",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "ampersand",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "at",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "daggerdbl",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "eth",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "lslash",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "AE,AEacute",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "parenright",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "J",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "J.aalt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "slash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "b,h,k,germandbls,thorn,hbar,uni0137",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,ij,i.aalt,glyph384",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "j,uni0237",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "l,lacute,uni013C,lcaron,ldot",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    g2: "M",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,endash,emdash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "quoteright,quotedblright",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "quotedbl,quotesingle",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eth",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "lslash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "one",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ordmasculine",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "space",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "trademark",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "uni02BC",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "zero",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "braceright",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eight",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "six",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "AE,AEacute",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 145
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J.aalt",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "slash",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "M",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "four",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "colon,semicolon",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "uni1E9E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ampersand",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "at",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "exclam",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "five",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "guillemotleft,guilsinglleft",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "hyphen,endash,emdash",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 158
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "quoteright,quotedblright",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "quotedbl,quotesingle",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "eth",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "lslash",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "nine",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "space",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "trademark",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "uni02BC",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "v",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "zero",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 158
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "copyright",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "eight",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "six",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "AE,AEacute",
    k: 215
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 178
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "J",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "J.aalt",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "slash",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "two",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "x",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "b,h,k,germandbls,thorn,hbar,uni0137",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,ij,i.aalt,glyph384",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "j,uni0237",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "l,lacute,uni013C,lcaron,ldot",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "M",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "four",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "guillemotright,guilsinglright",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "colon,semicolon",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "uni1E9E",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "ampersand",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "at",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "daggerdbl",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "five",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "ampersand.aalt",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "guillemotleft,guilsinglleft",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "hyphen,endash,emdash",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "eth",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "lslash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "nine",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "zero",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "six",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,ij,i.aalt,glyph384",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "four",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "AE,AEacute",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "b,h,k,germandbls,thorn,hbar,uni0137",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,ij,i.aalt,glyph384",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "j,uni0237",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "l,lacute,uni013C,lcaron,ldot",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "hyphen,endash,emdash",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "quoteleft,quotedblleft",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "quoteright,quotedblright",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "AE,AEacute",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 190
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,ij,i.aalt,glyph384",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "j,uni0237",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1E9E",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1E9E",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1E9E",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1E9E",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1E9E",
    g2: "quoteleft,quotedblleft",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1E9E",
    g2: "quoteright,quotedblright",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1E9E",
    g2: "quotedbl,quotesingle",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1E9E",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "hyphen,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "quoteright,quotedblright",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "b,h,k,germandbls,thorn,hbar,uni0137",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,ij,i.aalt,glyph384",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "l,lacute,uni013C,lcaron,ldot",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "hyphen,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "AE,AEacute",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 203
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,ij,i.aalt,glyph384",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "j,uni0237",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "AE,AEacute",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "b,h,k,germandbls,thorn,hbar,uni0137",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,ij,i.aalt,glyph384",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "j,uni0237",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "l,lacute,uni013C,lcaron,ldot",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotleft,guilsinglleft",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "hyphen,endash,emdash",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "quoteright,quotedblright",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "quotedbl,quotesingle",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "AE,AEacute",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 168
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "j,uni0237",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotright,guilsinglright",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "guillemotleft,guilsinglleft",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "hyphen,endash,emdash",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "quoteright,quotedblright",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "quotedbl,quotesingle",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "quoteleft,quotedblleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "quoteright,quotedblright",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "quotedbl,quotesingle",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "V",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "backslash",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "parenright",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "trademark",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "uni02BC",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "ordfeminine.aalt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "ordmasculine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteleft,quotedblleft",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteright,quotedblright",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quotedbl,quotesingle",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "V",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "backslash",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "parenright",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "trademark",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "uni02BC",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "v",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "ordfeminine.aalt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "ordmasculine",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "X",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "asterisk",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "braceright",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "bracketright",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "ordfeminine",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "question",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "registered",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "x",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "j,uni0237",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "slash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "quoteleft,quotedblleft",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "V",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "backslash",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "parenright",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "trademark",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "uni02BC",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "asterisk",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "ordfeminine",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "registered",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "x",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "hyphen,endash,emdash",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "eth",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "lslash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "guillemotleft,guilsinglleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "quoteleft,quotedblleft",
    k: -86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "quoteright,quotedblright",
    k: -180
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "quotedbl,quotesingle",
    k: -158
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "parenright",
    k: -193
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "trademark",
    k: -203
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "uni02BC",
    k: -227
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "v",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "ordfeminine.aalt",
    k: -109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "ordmasculine",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "asterisk",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "braceright",
    k: -213
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "bracketright",
    k: -195
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "ordfeminine",
    k: -127
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "question",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "registered",
    k: -102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "x",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "j,uni0237",
    k: -125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "hyphen,endash,emdash",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "guillemotleft,guilsinglleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "b,h,k,germandbls,thorn,hbar,uni0137",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,ij,i.aalt,glyph384",
    k: -127
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "l,lacute,uni013C,lcaron,ldot",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "exclam",
    k: -106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "space",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "quoteleft,quotedblleft",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "quoteright,quotedblright",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "quotedbl,quotesingle",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "V",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "backslash",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "parenright",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "trademark",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "uni02BC",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "ordfeminine.aalt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "ordmasculine",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "braceright",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "bracketright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "x",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "j,uni0237",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe,aeacute,ae.aalt,aeacute.aalt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "quoteleft,quotedblleft",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "backslash",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "uni02BC",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "ordfeminine.aalt",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "ordmasculine",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "braceright",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "ordfeminine",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "question",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "registered",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "hyphen,endash,emdash",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "eth",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "lslash",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "guillemotleft,guilsinglleft",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "space",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,uni0137,kgreenlandic",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,uni013C,uniFB02",
    g2: "middot",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 158
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "quoteleft,quotedblleft",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "quoteright,quotedblright",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "quotedbl,quotesingle",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "V",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "backslash",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "parenright",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "trademark",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "uni02BC",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "v",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "ordfeminine.aalt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "ordmasculine",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "quoteleft,quotedblleft",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "quoteright,quotedblright",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "quotedbl,quotesingle",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "V",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "backslash",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "parenright",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "trademark",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "uni02BC",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "v",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "ordfeminine.aalt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "ordmasculine",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "X",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "asterisk",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "braceright",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "bracketright",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "question",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "x",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "j,uni0237",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,ohungarumlaut,uni01EB,oslashacute",
    g2: "slash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "quoteleft,quotedblleft",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "parenright",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "uni02BC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "v",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "ordfeminine.aalt",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "ordmasculine",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "X",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "asterisk",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "braceright",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "bracketright",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "ordfeminine",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "question",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "registered",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "slash",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "hyphen,endash,emdash",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "eth",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "lslash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "guillemotleft,guilsinglleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "space",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "J",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "M",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "V",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "backslash",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "parenright",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "trademark",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "uni02BC",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "v",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "X",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "x",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "hyphen,endash,emdash",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "lslash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,f_t.dlig",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,f_t.dlig",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,f_t.dlig",
    g2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,f_t.dlig",
    g2: "backslash",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,f_t.dlig",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,f_t.dlig",
    g2: "uni02BC",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,f_t.dlig",
    g2: "question",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,f_t.dlig",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,f_t.dlig",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,f_t.dlig",
    g2: "hyphen,endash,emdash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,f_t.dlig",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,f_t.dlig",
    g2: "eth",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,f_t.dlig",
    g2: "lslash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,u,ugrave,uacute,ucircumflex,udieresis,gbreve,gdotaccent,uni0123,utilde,umacron,uring,uhungarumlaut,uogonek,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,u,ugrave,uacute,ucircumflex,udieresis,gbreve,gdotaccent,uni0123,utilde,umacron,uring,uhungarumlaut,uogonek,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,u,ugrave,uacute,ucircumflex,udieresis,gbreve,gdotaccent,uni0123,utilde,umacron,uring,uhungarumlaut,uogonek,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,u,ugrave,uacute,ucircumflex,udieresis,gbreve,gdotaccent,uni0123,utilde,umacron,uring,uhungarumlaut,uogonek,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt",
    g2: "V",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,u,ugrave,uacute,ucircumflex,udieresis,gbreve,gdotaccent,uni0123,utilde,umacron,uring,uhungarumlaut,uogonek,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt",
    g2: "backslash",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,u,ugrave,uacute,ucircumflex,udieresis,gbreve,gdotaccent,uni0123,utilde,umacron,uring,uhungarumlaut,uogonek,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt",
    g2: "parenright",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,u,ugrave,uacute,ucircumflex,udieresis,gbreve,gdotaccent,uni0123,utilde,umacron,uring,uhungarumlaut,uogonek,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt",
    g2: "trademark",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,u,ugrave,uacute,ucircumflex,udieresis,gbreve,gdotaccent,uni0123,utilde,umacron,uring,uhungarumlaut,uogonek,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt",
    g2: "uni02BC",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,u,ugrave,uacute,ucircumflex,udieresis,gbreve,gdotaccent,uni0123,utilde,umacron,uring,uhungarumlaut,uogonek,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "quoteleft,quotedblleft",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "parenright",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "uni02BC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "ordfeminine.aalt",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "ordmasculine",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "X",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "asterisk",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "braceright",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "bracketright",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "ordfeminine",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "question",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "registered",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "slash",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "hyphen,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "eth",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "lslash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "space",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "J",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "M",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "quoteleft,quotedblleft",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "parenright",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "uni02BC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "ordfeminine.aalt",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "ordmasculine",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "X",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "asterisk",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "braceright",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "bracketright",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "ordfeminine",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "question",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "registered",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "j,uni0237",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "slash",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "hyphen,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "eth",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "lslash",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "space",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "J",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "M",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "V",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "backslash",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "parenright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "trademark",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "uni02BC",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "hyphen,endash,emdash",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "eth",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "lslash",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "guillemotleft,guilsinglleft",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "j,uni0237",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "quoteleft,quotedblleft",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "quoteright,quotedblright",
    k: -102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "quotedbl,quotesingle",
    k: -109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "hyphen,endash,emdash",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "guillemotleft,guilsinglleft",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "j,uni0237",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "lslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "lslash",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "lslash",
    g2: "j,uni0237",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "lslash",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "lslash",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "lslash",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "lslash",
    g2: "hyphen,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "lslash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "lslash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "quoteleft,quotedblleft",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "j,uni0237",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "hyphen,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "quoteleft,quotedblleft",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "hyphen,endash,emdash",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "guillemotleft,guilsinglleft",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,uniFB01,i.aalt",
    g2: "trademark",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j,ij,uni0237,glyph384",
    g2: "trademark",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "lslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "AE,AEacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "AE,AEacute",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "x",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "V",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "AE,AEacute",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "J",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "X",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "x",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "J.aalt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "M",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "v",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 145
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 178
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "V",
    k: 168
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "lslash",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "J",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "v",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "eth",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "V",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "lslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "AE,AEacute",
    k: 186
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J",
    k: 201
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "x",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J.aalt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "M",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "v",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "eth",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "V",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "lslash",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "AE,AEacute",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J",
    k: 201
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "X",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "x",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J.aalt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "M",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "v",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "eth",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni1E9E",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "V",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "lslash",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "AE,AEacute",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "X",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J.aalt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "M",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "eth",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "AE,AEacute",
    k: 174
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "AE,AEacute",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "j,uni0237",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "AE,AEacute",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "j,uni0237",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "AE,AEacute",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "j,uni0237",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "j,uni0237",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "middot",
    g2: "l,lacute,uni013C,lcaron,ldot",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "AE,AEacute",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Uring,Uhungarumlaut,Uogonek",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "j,uni0237",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "AE,AEacute",
    k: 201
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "underscore",
    g2: "AE,AEacute",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "underscore",
    g2: "j,uni0237",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "AE,AEacute",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "j,uni0237",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand.aalt",
    g2: "AE,AEacute",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand.aalt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand.aalt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand.aalt",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand.aalt",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "AE,AEacute",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "copyright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "copyright",
    g2: "AE,AEacute",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "copyright",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "copyright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dagger",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dagger",
    g2: "AE,AEacute",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dagger",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "daggerdbl",
    g2: "AE,AEacute",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "daggerdbl",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "daggerdbl",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "registered",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "registered",
    g2: "AE,AEacute",
    k: 174
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "registered",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "registered",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "registered",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "registered",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "registered",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordfeminine",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordfeminine.aalt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordmasculine",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 215
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "AE,AEacute",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 190
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "AE,AEacute",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE,uni01EA,Oslashacute,Q.aalt",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "d,q,dcaron,dslash,a.salt,aacute.aalt,abreve.aalt,acircumflex.aalt,adieresis.aalt,agrave.aalt,amacron.aalt,aogonek.aalt,aring.aalt,atilde.aalt,ae.aalt,aeacute.aalt",
    k: 186
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "f,uniFB01,uniFB02,f_t.dlig",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "m,n,p,r,ntilde,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe,uni01EB,oslashacute",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "t,uni0163,tcaron,tbar,uni021B",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,uring,uhungarumlaut,uogonek",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "B,D,E,F,H,I,K,L,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Edotaccent,Eogonek,Ecaron,Hbar,Itilde,Imacron,Iogonek,Idot,IJ,uni0136,Lacute,uni013B,Lcaron,Ldot,Lslash,Nacute,uni0145,Ncaron,Eng,Racute,uni0156,Rcaron,glyph382,glyph383",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,iogonek,dotlessi,ij,i.aalt,glyph384",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni02BC",
    g2: "j,uni0237",
    k: -4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsidoraSansSemiBold);
export default __webpack_public_path__ + "static/media/IsidoraSans-SemiBold.19880573cced82368e0dac98ea56a956.svg";
export { ForwardRef as ReactComponent };